/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/gloomhaven/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 57);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(64);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return END_TURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_SCENARIO; });
/* harmony export (immutable) */ __webpack_exports__["d"] = endTurnAction;
/* harmony export (immutable) */ __webpack_exports__["c"] = endScenarioAction;
var END_TURN='endTurn';var END_SCENARIO='endScenario';function endTurnAction(dispatch){dispatch({type:END_TURN});}function endScenarioAction(dispatch){dispatch({type:END_SCENARIO});}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISARM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IMMOBILIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INVISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MUDDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return POISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STRENGTHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WOUND; });
/* unused harmony export REGENERATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STATUS_EFFECTS; });
/* harmony export (immutable) */ __webpack_exports__["o"] = newStatusEffectTracker;
/* unused harmony export ALL_STATUS_EFFECTS */
/* harmony export (immutable) */ __webpack_exports__["n"] = iconForStatusEffect;
/* harmony export (immutable) */ __webpack_exports__["q"] = push;
/* harmony export (immutable) */ __webpack_exports__["p"] = pull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curse_svg__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__curse_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bless_svg__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disarm_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disarm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__disarm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__immobilize_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__immobilize_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__immobilize_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__invisible_svg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__invisible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__invisible_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__muddle_svg__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__muddle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__muddle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__poison_svg__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__poison_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__poison_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__strengthen_svg__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__strengthen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__strengthen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stun_svg__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stun_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__stun_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wound_svg__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wound_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__wound_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__regenerate_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__regenerate_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__regenerate_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__push_svg__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__push_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__push_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pull_svg__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pull_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pull_svg__);
var _statusEffectIcons,_Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BLESS="BLESS";var CURSE="CURSE";var DISARM="DISARM";var IMMOBILIZE="IMMOBILIZE";var INVISIBLE="INVISIBLE";var MUDDLE="MUDDLE";var POISON="POISON";var STRENGTHEN="STRENGTHEN";var STUN="STUN";var WOUND="WOUND";var REGENERATE="REGENERATE";var PUSH="PUSH";var PULL="PULL";var statusEffectIcons=(_statusEffectIcons={},_defineProperty(_statusEffectIcons,POISON,__WEBPACK_IMPORTED_MODULE_6__poison_svg___default.a),_defineProperty(_statusEffectIcons,WOUND,__WEBPACK_IMPORTED_MODULE_9__wound_svg___default.a),_defineProperty(_statusEffectIcons,IMMOBILIZE,__WEBPACK_IMPORTED_MODULE_3__immobilize_svg___default.a),_defineProperty(_statusEffectIcons,DISARM,__WEBPACK_IMPORTED_MODULE_2__disarm_svg___default.a),_defineProperty(_statusEffectIcons,STUN,__WEBPACK_IMPORTED_MODULE_8__stun_svg___default.a),_defineProperty(_statusEffectIcons,MUDDLE,__WEBPACK_IMPORTED_MODULE_5__muddle_svg___default.a),_defineProperty(_statusEffectIcons,INVISIBLE,__WEBPACK_IMPORTED_MODULE_4__invisible_svg___default.a),_defineProperty(_statusEffectIcons,STRENGTHEN,__WEBPACK_IMPORTED_MODULE_7__strengthen_svg___default.a),_defineProperty(_statusEffectIcons,REGENERATE,__WEBPACK_IMPORTED_MODULE_10__regenerate_png___default.a),_statusEffectIcons);var STATUS_EFFECTS=Object.keys(statusEffectIcons);function newStatusEffectTracker(){return STATUS_EFFECTS.reduce(function(acc,s){acc[s]=false;return acc;},{});}var allStatusEffectIcons=Object.assign({},statusEffectIcons,(_Object$assign={},_defineProperty(_Object$assign,PUSH,__WEBPACK_IMPORTED_MODULE_11__push_svg___default.a),_defineProperty(_Object$assign,PULL,__WEBPACK_IMPORTED_MODULE_12__pull_svg___default.a),_defineProperty(_Object$assign,CURSE,__WEBPACK_IMPORTED_MODULE_0__curse_svg___default.a),_defineProperty(_Object$assign,BLESS,__WEBPACK_IMPORTED_MODULE_1__bless_svg___default.a),_Object$assign));var ALL_STATUS_EFFECTS=Object.keys(allStatusEffectIcons);function iconForStatusEffect(name){return allStatusEffectIcons[name];}function push(value){return{type:PUSH,value:value};}function pull(value){return{type:PULL,value:value};}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_PARTY; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadPartyAction;
var LOAD_PARTY="party/load";function loadPartyAction(dispatch,party){dispatch({type:LOAD_PARTY,party:party});}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony export (immutable) */ __webpack_exports__["f"] = setXPAction;
/* harmony export (immutable) */ __webpack_exports__["d"] = setLevelAction;
/* harmony export (immutable) */ __webpack_exports__["e"] = setLevelAdjustmentAction;
/* harmony export (immutable) */ __webpack_exports__["g"] = toggleStatusEffectAction;
/* harmony export (immutable) */ __webpack_exports__["c"] = setHPAction;
/* unused harmony export setIntiativeAction */
/* unused harmony export unsetIntiativeAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_classes__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_players__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_turn__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function newPlayer(characterClass,level){var xp=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var stats=Object(__WEBPACK_IMPORTED_MODULE_0__lib_classes__["b" /* getCharacterStats */])(characterClass,level-1);return{level:level,class:characterClass,hp:stats.maxHP,maxHP:stats.maxHP,statusEffects:Object(__WEBPACK_IMPORTED_MODULE_1__lib_statusEffects__["o" /* newStatusEffectTracker */])(),initiative:null,xp:xp};}var defaultState={levelAdjustment:0,selectableClasses:__WEBPACK_IMPORTED_MODULE_0__lib_classes__["a" /* CLASS_NAMES */].reduce(function(acc,c){acc[c]=true;return acc;},{}),players:{}};var SET_XP='players/xp/set';var SET_LEVEL='players/level/set';var SET_LEVEL_ADJUSTMENT='players/level/setAdjustment';var TOGGLE_STATUS_EFFECT='players/statusEffect/toggle';var SET_HP='players/hp/set';var SET_INITIATIVE='players/initiative/set';var UNSET_INITIATIVE='players/initiative/unset';var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions_party__["a" /* LOAD_PARTY */]:{var loadedPlayers=Object.entries(action.party[0]).reduce(function(acc,_ref){var _ref2=_slicedToArray(_ref,2),playerName=_ref2[0],playerData=_ref2[1];acc[playerName]=newPlayer(playerData.class,playerData.level,playerData.xp);return acc;},{});return Object.assign({},defaultState,{players:loadedPlayers});}case __WEBPACK_IMPORTED_MODULE_3__actions_players__["a" /* ADD_PLAYER */]:{var players=Object.assign({},state.players,_defineProperty({},action.name,Object.assign({},newPlayer(action.class,action.level||1))));// localStorage.setItem('Gloomhaven_Data_players', JSON.stringify(players));
return Object.assign({},state,{selectableClasses:Object.assign({},state.selectableClasses,_defineProperty({},action.class,false)),players:players});}case __WEBPACK_IMPORTED_MODULE_3__actions_players__["b" /* REMOVE_PLAYER */]:{var player=state.players[action.name];var newPlayers=Object.assign({},state.players);delete newPlayers[action.name];// localStorage.setItem('Gloomhaven_Data_players', JSON.stringify(newPlayers));
return Object.assign({},state,{selectableClasses:Object.assign({},state.selectableClasses,_defineProperty({},player.class,true)),players:newPlayers,initiative:{}});}case SET_XP:{var _player=state.players[action.name];_player.xp=action.xp;// console.log('SET_XP', player);
return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.name,_player))});}case SET_LEVEL:{var _player2=state.players[action.name];return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.name,Object.assign({},newPlayer(_player2.class,action.level))))});}case SET_LEVEL_ADJUSTMENT:{return Object.assign({},state,{levelAdjustment:action.levelAdjustment});}case TOGGLE_STATUS_EFFECT:{var _player3=state.players[action.name];return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.name,Object.assign({},_player3,{statusEffects:Object.assign({},_player3.statusEffects,_defineProperty({},action.statusEffect,!_player3.statusEffects[action.statusEffect]))})))});}case SET_HP:{var _player4=state.players[action.name];return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.name,Object.assign({},_player4,{hp:action.hp})))});}case SET_INITIATIVE:{return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.playerName,Object.assign({},state.players[action.playerName],{initiative:action.initiative})))});}case UNSET_INITIATIVE:{return Object.assign({},state,{players:Object.assign({},state.players,_defineProperty({},action.playerName,Object.assign({},state.players[action.playerName],{initiative:null})))});}case __WEBPACK_IMPORTED_MODULE_4__actions_turn__["b" /* END_TURN */]:{var _newPlayers=Object.entries(state.players).reduce(function(acc,_ref3){var _ref4=_slicedToArray(_ref3,2),name=_ref4[0],player=_ref4[1];var newPlayer=Object.assign({},player,{initiative:null});acc[name]=newPlayer;return acc;},{});return Object.assign({},state,{players:_newPlayers});}default:return state;}};function setXPAction(dispatch,name,xp){dispatch({type:SET_XP,name:name,xp:xp});}function setLevelAction(dispatch,name,level){dispatch({type:SET_LEVEL,name:name,level:level});}function setLevelAdjustmentAction(dispatch,levelAdjustment){dispatch({type:SET_LEVEL_ADJUSTMENT,levelAdjustment:levelAdjustment});}function toggleStatusEffectAction(dispatch,name,statusEffect){dispatch({type:TOGGLE_STATUS_EFFECT,name:name,statusEffect:statusEffect});}function setHPAction(dispatch,name,hp){dispatch({type:SET_HP,name:name,hp:hp});}function setIntiativeAction(dispatch,playerName,initiative){dispatch({type:SET_INITIATIVE,playerName:playerName,initiative:initiative});}function unsetIntiativeAction(dispatch,playerName){dispatch({type:UNSET_INITIATIVE,playerName:playerName});}function calculateScenarioLevel(players){var playerNames=Object.keys(players);if(playerNames.length===0){return 0;}var averageLevel=playerNames.reduce(function(sum,p){var player=players[p];return sum+player.level;},0)/playerNames.length;return Math.ceil(averageLevel/2);}var selectors={selectableClasses:function selectableClasses(state){return Object.keys(state.players.selectableClasses).filter(function(c){return state.players.selectableClasses[c];});},numPlayers:function numPlayers(state){return Object.keys(state.players.players).length;},baseScenarioLevel:function baseScenarioLevel(state){return calculateScenarioLevel(state.players.players);},// + level adjustment
scenarioLevel:function scenarioLevel(state){return calculateScenarioLevel(state.players.players)+state.players.levelAdjustment;},initiatives:function initiatives(state){return Object.entries(state.players.players).reduce(function(acc,_ref5){var _ref6=_slicedToArray(_ref5,2),name=_ref6[0],player=_ref6[1];if(!player.initiative){return acc;}acc[player.initiative]=(acc[player.initiative]||[]).concat(name);return acc;},{});}};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony export (immutable) */ __webpack_exports__["e"] = toggleAliveAction;
/* harmony export (immutable) */ __webpack_exports__["h"] = toggleEliteAction;
/* harmony export (immutable) */ __webpack_exports__["g"] = toggleAllowIndividualMonsterLevels;
/* unused harmony export setLevelAction */
/* harmony export (immutable) */ __webpack_exports__["f"] = toggleAllStatusEffectsAction;
/* harmony export (immutable) */ __webpack_exports__["i"] = toggleStatusEffectAction;
/* harmony export (immutable) */ __webpack_exports__["d"] = setHPAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = dealDamageAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_monsters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_turn__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function newMonster(name,level,alive,elite){var monsterStats=__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["d" /* MONSTERS */][name].stats[level];var stats=elite?monsterStats.elite:monsterStats.normal;return{alive:alive,elite:elite,level:level,maxHP:stats.maxHP,currentHP:stats.maxHP,statusEffects:Object(__WEBPACK_IMPORTED_MODULE_0__lib_statusEffects__["o" /* newStatusEffectTracker */])()};}function newMonsters(name,level){var monster=__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["d" /* MONSTERS */][name];return{monsters:new Array(monster.tokenCount).fill(newMonster(name,level,false,false))};}function getAllStatusEffects(monsters){var aliveMonsters=monsters.filter(function(m){return m.alive;});return __WEBPACK_IMPORTED_MODULE_0__lib_statusEffects__["j" /* STATUS_EFFECTS */].reduce(function(acc,s){if(aliveMonsters.length===0){acc[s]=false;return acc;}acc[s]=true;aliveMonsters.forEach(function(m){acc[s]=acc[s]&&m.statusEffects[s];});return acc;},{});}var defaultState={allowIndividualMonsterLevels:false,monsters:{}};var TOGGLE_ELITE='monsters/toggleElite';var TOGGLE_ALIVE='monsters/toggleAlive';var TOGGLE_ALLOW_INDIVIDUAL_MONSTER_LEVELS='monsters/level/allowSetting/toggle';var SET_LEVEL='monsters/level/set';var TOGGLE_ALL_STATUS_EFFECTS='monsters/statusEffect/setAll';var TOGGLE_STATUS_EFFECT='monsters/statusEffect/toggle';var SET_HP='monsters/hp/set';var DEAL_DAMAGE='monsters/hp/damage';var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions_party__["a" /* LOAD_PARTY */]:{var loadedMonsters=Object.entries(action.party[1]).reduce(function(acc,_ref){var _ref2=_slicedToArray(_ref,2),monsterName=_ref2[0],monstersData=_ref2[1];acc[monsterName]=monstersData;return acc;},{});return Object.assign({},defaultState,{monsters:loadedMonsters});}case __WEBPACK_IMPORTED_MODULE_3__actions_monsters__["c" /* RESET_MONSTERS */]:return defaultState;case __WEBPACK_IMPORTED_MODULE_3__actions_monsters__["a" /* ADD_MONSTERS */]:{return Object.assign({},state,{monsters:Object.assign({},state.monsters,action.monsters.reduce(function(acc,name){acc[name]=newMonsters(name,action.level,action.numPlayers);return acc;},{}))});}case __WEBPACK_IMPORTED_MODULE_3__actions_monsters__["b" /* REMOVE_MONSTER */]:{var newState=Object.assign({},state,{monsters:Object.assign({},state.monsters)});delete newState.monsters[action.name];return newState;}case TOGGLE_ELITE:{var monsters=state.monsters[action.name].monsters;var monster=monsters[action.index];return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(monsters.slice(0,action.index)),[newMonster(action.name,monster.level,monster.alive,!monster.elite)],_toConsumableArray(monsters.slice(action.index+1)))}))});}case TOGGLE_ALIVE:{var _monsters=state.monsters[action.name].monsters;var _monster=_monsters[action.index];return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters.slice(0,action.index)),[newMonster(action.name,_monster.level,!_monster.alive,_monster.elite)],_toConsumableArray(_monsters.slice(action.index+1)))}))});}case TOGGLE_ALLOW_INDIVIDUAL_MONSTER_LEVELS:{return Object.assign({},state,{allowIndividualMonsterLevels:!state.allowIndividualMonsterLevels});}case SET_LEVEL:{var _monsters2=state.monsters[action.name].monsters;var _monster2=_monsters2[action.index];return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters2.slice(0,action.index)),[newMonster(action.name,action.level,_monster2.alive,_monster2.elite)],_toConsumableArray(_monsters2.slice(action.index+1)))}))});}case TOGGLE_ALL_STATUS_EFFECTS:{var _monsters3=state.monsters[action.name].monsters;var allStatusEffects=getAllStatusEffects(_monsters3);return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:_monsters3.map(function(m){if(!m.alive){return m;}return Object.assign({},m,{statusEffects:Object.assign({},m.statusEffects,_defineProperty({},action.statusEffect,!allStatusEffects[action.statusEffect]))});})}))});}case TOGGLE_STATUS_EFFECT:{var _monsters4=state.monsters[action.name].monsters;var _monster3=_monsters4[action.index];return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters4.slice(0,action.index)),[Object.assign({},_monster3,{statusEffects:Object.assign({},_monster3.statusEffects,_defineProperty({},action.statusEffect,!_monster3.statusEffects[action.statusEffect]))})],_toConsumableArray(_monsters4.slice(action.index+1)))}))});}case SET_HP:{var _monsters5=state.monsters[action.name].monsters;var _monster4=_monsters5[action.index];return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters5.slice(0,action.index)),[Object.assign({},_monster4,{currentHP:action.hp})],_toConsumableArray(_monsters5.slice(action.index+1)))}))});}case DEAL_DAMAGE:{var _monsters6=state.monsters[action.name].monsters;var _monster5=_monsters6[action.index];var currentHP=_monster5.currentHP-action.damage;if(currentHP>_monster5.maxHP){return Object.assign({},state);}// console.log('DEAL_DAMAGE', monster, monster.currentHP, action.damage, currentHP);
if(currentHP>0){return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters6.slice(0,action.index)),[Object.assign({},_monster5,{currentHP:currentHP})],_toConsumableArray(_monsters6.slice(action.index+1)))}))});}else{return Object.assign({},state,{monsters:Object.assign({},state.monsters,_defineProperty({},action.name,{monsters:[].concat(_toConsumableArray(_monsters6.slice(0,action.index)),[newMonster(action.name,_monster5.level,false,_monster5.elite)],_toConsumableArray(_monsters6.slice(action.index+1)))}))});}}case __WEBPACK_IMPORTED_MODULE_4__actions_turn__["a" /* END_SCENARIO */]:{return defaultState;}default:return state;}};function toggleAliveAction(dispatch,name,index){dispatch({type:TOGGLE_ALIVE,name:name,index:index});}function toggleEliteAction(dispatch,name,index){dispatch({type:TOGGLE_ELITE,name:name,index:index});}function toggleAllowIndividualMonsterLevels(dispatch){dispatch({type:TOGGLE_ALLOW_INDIVIDUAL_MONSTER_LEVELS});}function setLevelAction(dispatch,name,index,level){dispatch({type:SET_LEVEL,name:name,index:index,level:level});}function toggleAllStatusEffectsAction(dispatch,name,statusEffect){dispatch({type:TOGGLE_ALL_STATUS_EFFECTS,name:name,statusEffect:statusEffect});}function toggleStatusEffectAction(dispatch,name,index,statusEffect){dispatch({type:TOGGLE_STATUS_EFFECT,name:name,index:index,statusEffect:statusEffect});}function setHPAction(dispatch,name,index,hp){dispatch({type:SET_HP,name:name,index:index,hp:hp});}function dealDamageAction(dispatch,name,index,damage){dispatch({type:DEAL_DAMAGE,name:name,index:index,damage:damage});}var selectors={// status effects across all monsters
allStatusEffects:function allStatusEffects(state,name){return getAllStatusEffects(state.monsters.monsters[name].monsters);},isActive:function isActive(state,name){return state.monsters.monsters[name].monsters.some(function(m){return m.alive;});},hasMonstersInPlay:function hasMonstersInPlay(state){return state.boss!=null||Object.keys(state.monsters.monsters).length>0;},hasMonstersAlive:function hasMonstersAlive(state){var gotAlive=false;Object.keys(state.monsters.monsters).forEach(function(key){if(state.monsters.monsters[key].monsters.some(function(m){return m.alive;}))gotAlive=true;});return gotAlive;}};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NUMBER_MODIFIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return END_ACTIONS; });
/* harmony export (immutable) */ __webpack_exports__["g"] = iconForEndAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BLESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BASE_DECK; });
/* harmony export (immutable) */ __webpack_exports__["i"] = shuffle;
/* harmony export (immutable) */ __webpack_exports__["h"] = needsShuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffle_svg__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shuffle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rolling_svg__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rolling_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rolling_svg__);
var _endActionIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PLUS_ONE="+1";var PLUS_TWO="+2";var PLUS_THREE="+3";var PLUS_FOUR="+4";var PLUS_ZERO="+0";var MINUS_ONE="-1";var MINUS_TWO="-2";var NULL="null";var TIMES_TWO="x2";var NUMBER_MODIFIERS={PLUS_ONE:PLUS_ONE,PLUS_TWO:PLUS_TWO,PLUS_THREE:PLUS_THREE,PLUS_FOUR:PLUS_FOUR,PLUS_ZERO:PLUS_ZERO,MINUS_ONE:MINUS_ONE,MINUS_TWO:MINUS_TWO,NULL:NULL,TIMES_TWO:TIMES_TWO};var SHUFFLE="shuffle";var DISCARD="discard";var ROLLING="rolling";var END_ACTIONS={SHUFFLE:SHUFFLE,DISCARD:DISCARD,ROLLING:ROLLING};var endActionIcons=(_endActionIcons={},_defineProperty(_endActionIcons,SHUFFLE,__WEBPACK_IMPORTED_MODULE_0__shuffle_svg___default.a),_defineProperty(_endActionIcons,ROLLING,__WEBPACK_IMPORTED_MODULE_1__rolling_svg___default.a),_endActionIcons);function iconForEndAction(name){return endActionIcons[name];}var BASE_CARDS={PLUS_ZERO:{modifier:PLUS_ZERO},PLUS_ONE:{modifier:PLUS_ONE},PLUS_TWO:{modifier:PLUS_TWO},MINUS_ONE:{modifier:MINUS_ONE},MINUS_TWO:{modifier:MINUS_TWO},TIMES_TWO:{modifier:TIMES_TWO,endAction:SHUFFLE},NULL:{modifier:NULL,endAction:SHUFFLE}};var CURSE={modifier:NULL,endAction:DISCARD};var BLESS={modifier:TIMES_TWO,endAction:DISCARD};var BASE_DECK=[BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.PLUS_TWO,BASE_CARDS.MINUS_TWO,BASE_CARDS.TIMES_TWO,BASE_CARDS.NULL];// https://gist.github.com/guilhermepontes/17ae0cc71fa2b13ea8c20c94c5c35dc4#gistcomment-2271465
function shuffle(cards){return cards.map(function(a){return[Math.random(),a];}).sort(function(a,b){return a[0]-b[0];}).map(function(a){return a[1];});}function needsShuffle(_ref){var cards=_ref.cards,currentIndex=_ref.currentIndex;return cards.filter(function(_,i){return i<=currentIndex;}).some(function(c){return c.endAction===END_ACTIONS.SHUFFLE;});}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MONSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MONSTER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOSS_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOSS_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOSS_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cards__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(24);
var ARCHER_CARDS=[{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:56,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"+1")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")])]},{initiative:44,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"Create a 3 damage trap in an adjacent empty hex closest to an enemy."]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var GUARD_CARDS=[{initiative:70,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:30,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:55,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STRENGTHEN */],null,["Self"])]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var IMP_CARDS=[{initiative:24,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STRENGTHEN */],null,[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Affect all allies within ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Target all enemies within ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")])])]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:76,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:42,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])]},{initiative:5,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"1",["Self"])]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var SHAMAN_CARDS=[{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */])])]},{initiative:9,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"1",["Affect all adjacent allies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["a" /* BLESS */],null,["Self"])]},{initiative:62,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},{initiative:74,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]}];var SCOUT_CARDS=[{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])]},{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* JUMP */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* LOOT */],"1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:40,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:53,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:54,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:69,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:79,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:92,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}];var MONSTERS={"Ancient Artillery":{tokenCount:6,stats:[{normal:{maxHP:4,move:0,attack:2,range:4,extra:[]},elite:{maxHP:7,move:0,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:0,attack:2,range:4,extra:[]},elite:{maxHP:9,move:0,attack:3,range:5,extra:[]}},{normal:{maxHP:7,move:0,attack:2,range:5,extra:[]},elite:{maxHP:11,move:0,attack:3,range:6,extra:[]}},{normal:{maxHP:8,move:0,attack:3,range:5,extra:[]},elite:{maxHP:13,move:0,attack:4,range:6,extra:[]}},{normal:{maxHP:9,move:0,attack:4,range:5,extra:[]},elite:{maxHP:13,move:0,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]}},{normal:{maxHP:11,move:0,attack:4,range:6,extra:[]},elite:{maxHP:15,move:0,attack:4,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]}},{normal:{maxHP:14,move:0,attack:4,range:6,extra:[]},elite:{maxHP:16,move:0,attack:5,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]}},{normal:{maxHP:16,move:0,attack:4,range:7,extra:[]},elite:{maxHP:20,move:0,attack:5,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]}}],cards:[{initiative:17,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2")]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a)]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)]},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)]},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"+2")])]},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["All adjacent enemies suffer 2 damage"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["All adjacent enemies suffer 2 damage"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:95,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]}]},"Bandit Archer":{tokenCount:6,stats:[{normal:{maxHP:4,move:2,attack:2,range:3,extra:[]},elite:{maxHP:6,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:5,move:2,attack:2,range:4,extra:[]},elite:{maxHP:7,move:2,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:3,attack:2,range:4,extra:[]},elite:{maxHP:9,move:3,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:4,extra:[]},elite:{maxHP:10,move:3,attack:4,range:5,extra:[]}},{normal:{maxHP:8,move:3,attack:3,range:4,extra:[]},elite:{maxHP:10,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:3,attack:3,range:5,extra:[]},elite:{maxHP:12,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:3,attack:4,range:5,extra:[]},elite:{maxHP:13,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:13,move:3,attack:4,range:5,extra:[]},elite:{maxHP:17,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:ARCHER_CARDS},"Bandit Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:2,range:0,extra:[]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[]},elite:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[]},elite:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:4,attack:4,range:0,extra:[]},elite:{maxHP:12,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:4,attack:4,range:0,extra:[]},elite:{maxHP:14,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:5,attack:4,range:0,extra:[]},elite:{maxHP:14,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}}],cards:GUARD_CARDS},"Black Imp":{tokenCount:10,stats:[{normal:{maxHP:3,move:1,attack:1,range:3,extra:[]},elite:{maxHP:4,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:1,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:6,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:5,move:1,attack:1,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:5,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:1,attack:3,range:4,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:7,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:11,move:1,attack:3,range:4,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:9,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:12,move:1,attack:3,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:1,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:14,move:1,attack:4,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:12,move:1,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:17,move:1,attack:4,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:IMP_CARDS},"Cave Bear":{tokenCount:4,stats:[{normal:{maxHP:7,move:3,attack:3,range:0,extra:[]},elite:{maxHP:11,move:3,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[]}},{normal:{maxHP:11,move:4,attack:3,range:0,extra:[]},elite:{maxHP:17,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:13,move:4,attack:4,range:0,extra:[]},elite:{maxHP:20,move:4,attack:5,range:0,extra:[]}},{normal:{maxHP:16,move:4,attack:4,range:0,extra:[]},elite:{maxHP:21,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:17,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:24,move:5,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:19,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:28,move:5,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:22,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:33,move:5,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}}],cards:[{initiative:3,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"])]},{initiative:13,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]},{initiative:34,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:80,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"City Archer":{tokenCount:6,stats:[{normal:{maxHP:4,move:1,attack:2,range:3,extra:[]},elite:{maxHP:6,move:1,attack:3,range:4,extra:[]}},{normal:{maxHP:5,move:1,attack:2,range:4,extra:[]},elite:{maxHP:6,move:1,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:1,attack:3,range:4,extra:[]},elite:{maxHP:7,move:1,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:8,move:2,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:8,move:2,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:10,move:2,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:2,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:12,move:3,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:13,move:3,attack:6,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}}],cards:ARCHER_CARDS},"City Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:8,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:12,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:13,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:13,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:14,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}}],cards:GUARD_CARDS},"Cultist":{tokenCount:6,stats:[{normal:{maxHP:4,move:2,attack:1,range:0,extra:[]},elite:{maxHP:7,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:5,move:2,attack:1,range:0,extra:[]},elite:{maxHP:9,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:7,move:2,attack:1,range:0,extra:[]},elite:{maxHP:12,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:1,range:0,extra:[]},elite:{maxHP:13,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:10,move:3,attack:2,range:0,extra:[]},elite:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:11,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:18,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:14,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:22,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:25,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}}],cards:[{initiative:39,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"1",["Self"])]},{initiative:10,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["On death:"],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",null,__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default.a)])]},{initiative:10,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["On death:"],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",null,__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default.a)])]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])]},{initiative:63,actions:["Summon normal Living Bones","Cultist suffers 2 damage."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:63,actions:["Summon normal Living Bones","Cultist suffers 2 damage."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}]},"Deep Terror":{tokenCount:10,stats:[{normal:{maxHP:3,move:0,attack:2,range:0,extra:[]},elite:{maxHP:5,move:0,attack:3,range:0,extra:[]}},{normal:{maxHP:4,move:0,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:6,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]}},{normal:{maxHP:4,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:7,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]}},{normal:{maxHP:5,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:8,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:6,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:9,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:7,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:11,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:8,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:13,move:0,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:9,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]},elite:{maxHP:15,move:0,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}}],cards:[{initiative:65,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])])]},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")],__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")],__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:84,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])])]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",["Target all adjacent enemies",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:96,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"6"),"Summon normal Deep Terror in a hex adjacent to the target"])]},{initiative:54,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])," and ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])],["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4")])]}]},"Earth Demon":{tokenCount:6,stats:[{normal:{maxHP:7,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:1,attack:3,range:0,extra:[]},elite:{maxHP:13,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:12,move:1,attack:3,range:0,extra:[]},elite:{maxHP:18,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:13,move:2,attack:3,range:0,extra:[]},elite:{maxHP:20,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:15,move:2,attack:4,range:0,extra:[]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:17,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:25,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:20,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:27,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:22,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:32,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}}],cards:[{initiative:93,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1")}]},{initiative:79,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["-2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */])])}]},{initiative:40,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",["Self"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],null,["Target all enemies within range 3"])}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:42,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:62,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")}]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]},{initiative:87,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]}]},"Flame Demon":{tokenCount:6,stats:[{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:3,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:4,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:5,move:4,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]},elite:{maxHP:6,move:4,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5")]}},{normal:{maxHP:4,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]},elite:{maxHP:7,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"5",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5")]}},{normal:{maxHP:5,move:4,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]},elite:{maxHP:8,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"5",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5")]}}],cards:[{initiative:30,actions:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],action:"All adjacent enemies suffer 2 damage."},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),"Create a 4 damage trap in an adjacent empty hex closest to an enemy.",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}]},{initiative:67,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}]},{initiative:3,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}]},{initiative:77,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:"Flame Demon suffers 1 damage"}]},{initiative:24,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}]},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],image:__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:49,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])])}]}]},"Frost Demon":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:3,range:0,extra:[]},elite:{maxHP:10,move:3,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:12,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:18,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:20,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}},{normal:{maxHP:14,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:25,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}}],cards:[{initiative:18,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],null,[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Target all enemies within ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")])]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",["Self"])}]},{initiative:18,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],action:"Frost Demon suffers 1 damage"}]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),", +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */])])}]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}]},{initiative:78,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:78,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"Forest Imp":{tokenCount:10,stats:[{normal:{maxHP:1,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:4,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:2,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:5,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:6,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:7,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:7,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:8,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:9,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:6,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:11,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}}],cards:IMP_CARDS},"Giant Viper":{tokenCount:10,stats:[{normal:{maxHP:2,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:3,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:3,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:3,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:7,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:6,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:11,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:13,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:8,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:17,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:[{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* JUMP */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* JUMP */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Add +2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"if the target is adjacent to any of the Giant Viper's allies."])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Add +2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"if the target is adjacent to any of the Giant Viper's allies."])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* JUMP */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* JUMP */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"All attacks targeting Giant Viper this round gain Disadvantage."]}]},"Harrower Infester":{tokenCount:4,stats:[{normal:{maxHP:6,move:2,attack:2,range:0,extra:[]},elite:{maxHP:12,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:12,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:14,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:10,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:17,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:19,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:15,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}},{normal:{maxHP:17,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]},elite:{maxHP:26,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}}],cards:[{initiative:2,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"5",["Self"])]},{initiative:30,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],['Perform "',Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2"),' Self" for each target damaged'])}]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),", ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */])])}]}]},"Hound":{tokenCount:6,stats:[{normal:{maxHP:4,move:3,attack:2,range:0,extra:[]},elite:{maxHP:6,move:5,attack:2,range:0,extra:[]}},{normal:{maxHP:4,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:6,move:5,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:7,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:8,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:11,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:9,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:12,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:11,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:15,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:15,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:15,move:6,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}}],cards:[{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2")])]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Add +2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"if the target is adjacent to any of the Hound's allies."])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Add +2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"if the target is adjacent to any of the Hound's allies."])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,["Target all adjacent enemies"])]},{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]}]},"Inox Archer":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:2,extra:[]},elite:{maxHP:7,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:6,move:2,attack:2,range:3,extra:[]},elite:{maxHP:8,move:2,attack:3,range:4,extra:[]}},{normal:{maxHP:8,move:2,attack:2,range:3,extra:[]},elite:{maxHP:11,move:2,attack:3,range:4,extra:[]}},{normal:{maxHP:9,move:2,attack:3,range:3,extra:[]},elite:{maxHP:13,move:2,attack:4,range:4,extra:[]}},{normal:{maxHP:10,move:3,attack:3,range:3,extra:[]},elite:{maxHP:14,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:12,move:3,attack:3,range:4,extra:[]},elite:{maxHP:17,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:12,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:19,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:15,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:23,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}}],cards:ARCHER_CARDS},"Inox Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:9,move:1,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]}},{normal:{maxHP:8,move:2,attack:2,range:0,extra:[]},elite:{maxHP:10,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:9,move:2,attack:3,range:0,extra:[]},elite:{maxHP:12,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:[]},elite:{maxHP:15,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:17,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")]}},{normal:{maxHP:13,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:19,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}},{normal:{maxHP:16,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"1")]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}},{normal:{maxHP:19,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2")]},elite:{maxHP:23,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")]}}],cards:GUARD_CARDS},"Inox Shaman":{tokenCount:4,stats:[{normal:{maxHP:4,move:1,attack:2,range:3,extra:[]},elite:{maxHP:6,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:6,move:1,attack:2,range:3,extra:[]},elite:{maxHP:9,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:7,move:2,attack:2,range:3,extra:[]},elite:{maxHP:11,move:3,attack:3,range:3,extra:[]}},{normal:{maxHP:9,move:2,attack:2,range:4,extra:[]},elite:{maxHP:14,move:3,attack:3,range:4,extra:[]}},{normal:{maxHP:10,move:2,attack:3,range:4,extra:[]},elite:{maxHP:16,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:13,move:2,attack:3,range:4,extra:[]},elite:{maxHP:20,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:15,move:3,attack:3,range:4,extra:[]},elite:{maxHP:24,move:4,attack:4,range:4,extra:[]}},{normal:{maxHP:16,move:3,attack:4,range:4,extra:[]},elite:{maxHP:27,move:4,attack:5,range:4,extra:[]}}],cards:SHAMAN_CARDS},"Living Bones":{tokenCount:10,stats:[{normal:{maxHP:5,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]},elite:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]}},{normal:{maxHP:5,move:3,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:5,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:7,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:13,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:14,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}}],cards:[{initiative:81,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")]},{initiative:45,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:64,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:12,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:45,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:74,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target one enemy with all attacks"])]},{initiative:25,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:20,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"Living Corpse":{tokenCount:6,stats:[{normal:{maxHP:5,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:1,attack:3,range:0,extra:[]}},{normal:{maxHP:7,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:1,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:1,attack:3,range:0,extra:[]},elite:{maxHP:13,move:1,attack:4,range:0,extra:[]}},{normal:{maxHP:10,move:1,attack:4,range:0,extra:[]},elite:{maxHP:13,move:2,attack:5,range:0,extra:[]}},{normal:{maxHP:11,move:2,attack:4,range:0,extra:[]},elite:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:13,move:2,attack:4,range:0,extra:[]},elite:{maxHP:17,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:14,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:21,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:25,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:[{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),"and ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]),["Target one adjacent enemy"]]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:47,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],null,["Target all adjacent enemies"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1")]),"Living Corpse suffers 1 damage"]},{initiative:91,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),"Living Corpse suffers 1 damage"]}]},"Living Spirit":{tokenCount:6,stats:[{normal:{maxHP:2,move:2,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:2,move:2,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:3,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:4,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:4,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:6,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:7,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:9,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}}],cards:[{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:33,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all enemies in range"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:48,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:48,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:55,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],null,["Target all enemies in range"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:67,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])}]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"1",["Self"])]}]},"Lurker":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]},elite:{maxHP:7,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"1")]},elite:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2")]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:12,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:16,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:18,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}}],cards:[{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2 instead")},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],null,["Target all adjacent enemies"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target one enemy with all attacks"])]},{initiative:41,actions:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STRENGTHEN */],null,["Self"])},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])])]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:64,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",["Target all adjacent enemies"])]}]},"Night Demon":{tokenCount:6,stats:[{normal:{maxHP:3,move:3,attack:3,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:5,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:5,move:3,attack:3,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:8,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:6,move:3,attack:4,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:11,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:7,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:13,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:8,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:15,move:5,attack:5,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:11,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:17,move:5,attack:6,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:14,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:21,move:5,attack:6,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:15,move:4,attack:6,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:21,move:5,attack:8,range:0,extra:["Attackers gain disadvantage"]}}],cards:[{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],null,["Self"])}]},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"All adjacent enemies and allies suffer 1 damage",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */])])}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])}]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])}]},{initiative:4,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]}]},"Ooze":{tokenCount:10,stats:[{normal:{maxHP:4,move:1,attack:2,range:2,extra:[]},elite:{maxHP:8,move:1,attack:2,range:3,extra:[]}},{normal:{maxHP:5,move:1,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:9,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:1,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:8,move:1,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:2,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:13,move:2,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:2,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:2,attack:4,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:16,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:2,attack:4,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:18,move:3,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}}],cards:[{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:57,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:59,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* LOOT */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"])]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"+1")])]},{initiative:85,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1")," and ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])],["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")])]},{initiative:94,actions:["Ooze suffers 2 damage","Summon normal Ooze with a hit point value equal to the summoning Ooze's current hit point value (limited by a normal Ooze's specified maximum hit point value)"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:94,actions:["Ooze suffers 2 damage","Summon normal Ooze with a hit point value equal to the summoning Ooze's current hit point value (limited by a normal Ooze's specified maximum hit point value)"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"Rending Drake":{tokenCount:6,stats:[{normal:{maxHP:5,move:3,attack:3,range:0,extra:[]},elite:{maxHP:7,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:7,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:7,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:9,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:7,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:10,move:5,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:9,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:11,move:6,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:10,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:14,move:6,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:11,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:15,move:6,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:14,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:18,move:6,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}}],cards:[{initiative:6,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STRENGTHEN */],null,["Self"])]},{initiative:12,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:13,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:25,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:39,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:54,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:59,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"Savvas Icestorm":{tokenCount:4,stats:[{normal:{maxHP:7,move:2,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")]},elite:{maxHP:12,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")]}},{normal:{maxHP:10,move:2,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")]},elite:{maxHP:12,move:2,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3")]},elite:{maxHP:15,move:3,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:18,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:14,move:3,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:19,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:21,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:23,move:4,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:17,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:24,move:4,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}}],cards:[{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),", ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"2"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+3 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */])])},{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")}]},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["Affect Self and all allies within ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"2")])]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}]},{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:47,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],null,["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:70,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"4 instead")},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"+1")])]},{initiative:98,actions:["Summon normal Wind Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]},{initiative:98,actions:["Summon normal Frost Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* ICE */]}]}]},"Savvas Lavaflow":{tokenCount:4,stats:[{normal:{maxHP:8,move:3,attack:2,range:0,extra:[]},elite:{maxHP:13,move:3,attack:3,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:18,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:14,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:21,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:16,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:24,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:18,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:27,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:20,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:30,move:4,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}},{normal:{maxHP:24,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]},elite:{maxHP:35,move:4,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */])]}}],cards:[{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")}]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"3")}]},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),", ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])}]},{initiative:51,actions:["All enemies suffer 2 damage",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),"all enemies"])},{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),"all enemies"])}]},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),"All allies and enemies adjacent to the target suffer 2 damage."]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:97,actions:["Summon normal Flame Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* FIRE */]}]},{initiative:97,actions:["Summon normal Earth Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]}]},"Spitting Drake":{tokenCount:6,stats:[{normal:{maxHP:5,move:3,attack:3,range:3,extra:[]},elite:{maxHP:8,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:3,extra:[]},elite:{maxHP:9,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:8,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:10,move:3,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:8,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:12,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:9,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:14,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:12,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:16,move:4,attack:6,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:13,move:4,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:19,move:4,attack:6,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:16,move:4,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:21,move:4,attack:7,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}}],cards:[{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:6,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STRENGTHEN */],null,["Self"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:52,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:87,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])])]},{initiative:57,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])],__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE}]},"Stone Golem":{tokenCount:6,stats:[{normal:{maxHP:10,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:1,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:1,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:14,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:1,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:12,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:17,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:13,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:19,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:16,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:20,move:3,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:16,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:21,move:3,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}}],cards:[{initiative:51,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:65,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:90,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")])]},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Stone Golem suffers 1 damage"]},{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Stone Golem suffers 2 damage"]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])]},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]}]},"Sun Demon":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:12,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:13,move:2,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:16,move:3,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:16,move:3,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:12,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:18,move:4,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:15,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}}],cards:[{initiative:95,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"4")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Target all enemies within range"}]},{initiative:88,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,["Self"])}]},{initiative:17,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Target all allies within range"}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:73,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"3",["Self"])}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */]}]},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */]}]},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */]}]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */]}]}]},"Vermling Scout":{tokenCount:10,stats:[{normal:{maxHP:2,move:3,attack:1,range:0,extra:[]},elite:{maxHP:4,move:3,attack:2,range:0,extra:[]}},{normal:{maxHP:3,move:3,attack:1,range:0,extra:[]},elite:{maxHP:5,move:3,attack:2,range:0,extra:[]}},{normal:{maxHP:3,move:3,attack:2,range:0,extra:[]},elite:{maxHP:5,move:4,attack:3,range:0,extra:[]}},{normal:{maxHP:5,move:3,attack:2,range:0,extra:[]},elite:{maxHP:7,move:4,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[]},elite:{maxHP:8,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:8,move:3,attack:3,range:0,extra:[]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:4,attack:3,range:0,extra:[]},elite:{maxHP:12,move:5,attack:4,range:0,extra:[]}},{normal:{maxHP:11,move:4,attack:3,range:0,extra:[]},elite:{maxHP:15,move:5,attack:4,range:0,extra:[]}}],cards:SCOUT_CARDS},"Vermling Shaman":{tokenCount:6,stats:[{normal:{maxHP:2,move:2,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:2,move:2,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:2,attack:1,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:4,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:2,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"4")]}},{normal:{maxHP:5,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5")]}},{normal:{maxHP:7,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:8,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"5")]}}],cards:SHAMAN_CARDS},"Wind Demon":{tokenCount:6,stats:[{normal:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]},elite:{maxHP:5,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:5,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:7,move:5,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:5,move:4,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:8,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:7,move:4,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:8,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]},elite:{maxHP:11,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:12,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}},{normal:{maxHP:11,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]},elite:{maxHP:13,move:5,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* FLYING */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"3")]}}],cards:[{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["+1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */])]),image:__WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg___default.a}]},{initiative:9,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"1",["Self"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])}]},{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2")}]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")}]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["-2 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */])])}]},{initiative:2,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]}]}};var MONSTER_LIST=Object.keys(MONSTERS);var BOSS_STATS={"Bandit Commander":[function(numPlayers){return{maxHP:8*numPlayers,move:3,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:4,attack:4,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:4,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:19*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:23*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"The Betrayer":[function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:4,range:3,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:3,attack:5,range:3,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:3,attack:6,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:7,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:4,attack:8,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:8,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:23*numPlayers,move:5,attack:9,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:27*numPlayers,move:5,attack:9,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Captain of the Guard":[function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:2,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:3,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:3,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:3,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:21*numPlayers,move:4,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:25*numPlayers,move:4,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* COMPOUND_TEXT */],["All allies add +1 ",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */]),"to all attacks this round"])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"The Colorless":[function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:2,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"4",["Self"]),"sheld 1"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:3,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"4",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:4,attack:3,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"5",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:4,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"5",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:4,attack:4,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"6",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:5,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"6",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:4,attack:6,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"7",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:19*numPlayers,move:5,attack:7,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["i" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* HEAL */],"7",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Dark Rider":[function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:"3+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:"3+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:3,attack:"3+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:3,attack:"4+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:3,attack:"4+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:3,attack:"5+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:"5+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:4,attack:"6+X",range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),"Summon Imp",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */]]};}],"Elder Drake":[function(numPlayers){return{maxHP:11*numPlayers,move:0,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:0,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:0,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:0,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:0,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:22*numPlayers,move:0,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:27*numPlayers,move:0,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:29*numPlayers,move:0,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */]]};}],"The Gloom":[function(numPlayers){return{maxHP:20*numPlayers,move:2,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:25*numPlayers,move:2,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:29*numPlayers,move:2,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:35*numPlayers,move:2,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:39*numPlayers,move:3,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:46*numPlayers,move:3,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:50*numPlayers,move:3,attack:8,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:56*numPlayers,move:3,attack:9,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Inox Bodyguard":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:1+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:1+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:2+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:3,attack:2+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"4")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:3,attack:3+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:3+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:4,attack:4+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"Jekserah":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:2,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:3,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:3,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:4,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:4,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:22*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Merciless Overseer":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:8*numPlayers,move:2,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:11*numPlayers,move:3,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:14*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:19*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};}],"Prime Demon":[function(numPlayers){return{maxHP:8*numPlayers,move:3,attack:4,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:4,attack:4,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:4,attack:5,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:6,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:5,attack:6,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:5,attack:7,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:7,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:22*numPlayers,move:5,attack:8,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["m" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"The Sightless Eye":[function(numPlayers){return{maxHP:7*numPlayers,attack:5,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:8*numPlayers,attack:6,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:10*numPlayers,attack:6,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:11*numPlayers,attack:7,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:14*numPlayers,attack:7,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:15*numPlayers,attack:8,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:18*numPlayers,attack:8,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:20*numPlayers,attack:9,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};}],"Winged Horror":[function(numPlayers){return{maxHP:6*numPlayers,move:3,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:4,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:8*numPlayers,move:4,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:4,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:5,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}]};var BOSS_CARDS=[{initiative:85,actions:["Special 1"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:73,actions:["Special 1"]},{initiative:52,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["l" /* TARGET */],"2")])]},{initiative:11,actions:["Special 2"]},{initiative:17,actions:["Special 2"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["e" /* END_ACTIONS */].SHUFFLE},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["m" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:79,actions:["Special 1"]},{initiative:14,actions:["Special 2"]}];var BOSS_LIST=Object.keys(BOSS_STATS);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EARTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIRE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WANING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STRONG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ELEMENTS; });
/* harmony export (immutable) */ __webpack_exports__["l"] = iconForElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__any_element_svg__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__any_element_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__any_element_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__air_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__air_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__air_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dark_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dark_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__earth_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__earth_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__earth_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fire_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fire_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fire_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ice_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ice_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ice_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__light_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__use_element_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__use_element_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__use_element_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__use_element_svg___default.a; });
var _elementIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ANY="any";var AIR="air";var DARK="dark";var EARTH="earth";var FIRE="fire";var ICE="ice";var LIGHT="light";var INERT="inert";var WANING="waning";var STRONG="strong";var elementIcons=(_elementIcons={},_defineProperty(_elementIcons,FIRE,__WEBPACK_IMPORTED_MODULE_4__fire_svg___default.a),_defineProperty(_elementIcons,ICE,__WEBPACK_IMPORTED_MODULE_5__ice_svg___default.a),_defineProperty(_elementIcons,AIR,__WEBPACK_IMPORTED_MODULE_1__air_svg___default.a),_defineProperty(_elementIcons,EARTH,__WEBPACK_IMPORTED_MODULE_3__earth_svg___default.a),_defineProperty(_elementIcons,LIGHT,__WEBPACK_IMPORTED_MODULE_6__light_svg___default.a),_defineProperty(_elementIcons,DARK,__WEBPACK_IMPORTED_MODULE_2__dark_svg___default.a),_elementIcons);var ELEMENTS=Object.keys(elementIcons);function iconForElement(name){return Object.assign({},elementIcons,_defineProperty({},ANY,__WEBPACK_IMPORTED_MODULE_0__any_element_svg___default.a))[name];}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(68);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_MONSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_MONSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_MONSTER; });
/* harmony export (immutable) */ __webpack_exports__["f"] = resetMonstersAction;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeMonsterAction;
/* harmony export (immutable) */ __webpack_exports__["d"] = addMonstersAction;
var RESET_MONSTERS="monsters/reset";var ADD_MONSTERS="monsters/add";var REMOVE_MONSTER="monsters/remove";function resetMonstersAction(dispatch){dispatch({type:RESET_MONSTERS});}function removeMonsterAction(dispatch,name){dispatch({type:REMOVE_MONSTER,name:name});}function addMonstersAction(dispatch,monsterNames,level){dispatch({type:ADD_MONSTERS,monsters:monsterNames,level:level});}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PLAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_PLAYER; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addPlayerAction;
/* unused harmony export resetPlayersAction */
/* harmony export (immutable) */ __webpack_exports__["d"] = removePlayerAction;
var ADD_PLAYER="players/add";var REMOVE_PLAYER="players/remove";var RESET_PLAYERS="players/reset";function addPlayerAction(dispatch,name,characterClass,level){dispatch({type:ADD_PLAYER,name:name,class:characterClass,level:level});}function resetPlayersAction(dispatch){dispatch({type:RESET_PLAYERS});}function removePlayerAction(dispatch,name){dispatch({type:REMOVE_PLAYER,name:name});}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(69)();
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = revealNextCardsAction;
/* harmony export (immutable) */ __webpack_exports__["d"] = toggleActiveAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_cards__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_monsters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_boss__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_turn__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function newDeck(cards,initialActive){return Object.assign({},shuffleDeck({cards:cards}),{active:initialActive});}function shuffleDeck(_ref){var cards=_ref.cards;return{cards:Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["i" /* shuffle */])(cards),currentIndex:-1,currentCard:null};}function revealNextCard(_ref2){var cards=_ref2.cards,currentIndex=_ref2.currentIndex,currentCard=_ref2.currentCard;var nextCards=cards;var nextIndex=currentIndex+1;if(currentCard&&currentCard.endAction===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["e" /* END_ACTIONS */].SHUFFLE||nextIndex>=cards.length){nextCards=Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["i" /* shuffle */])(cards);nextIndex=0;}var nextCard=nextCards[nextIndex];return{cards:nextCards,currentIndex:nextIndex,currentCard:nextCard};}function _hasActiveCards(decks){return Object.keys(decks).some(function(m){return decks[m].currentCard;});}var defaultState={};var REVEAL_CARDS='monsters/decks/next';var TOGGLE_ACTIVE='monsters/decks/toggleActive';var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__actions_party__["a" /* LOAD_PARTY */]:{var monsterDecks=Object.entries(action.party[1]).reduce(function(acc,_ref3){var _ref4=_slicedToArray(_ref3,2),monsterName=_ref4[0],monstersData=_ref4[1];var aliveMonsters=monstersData.monsters.filter(function(monster){return monster.alive;});var deck=newDeck(__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["d" /* MONSTERS */][monsterName].cards,aliveMonsters.length>0);acc[monsterName]=Object.assign({},deck);state=Object.assign({},state,{monsterDecks:_defineProperty({},monsterName,deck)});return acc;},{});return Object.assign({},defaultState,monsterDecks);}case __WEBPACK_IMPORTED_MODULE_2__actions_monsters__["c" /* RESET_MONSTERS */]:{return defaultState;}case __WEBPACK_IMPORTED_MODULE_2__actions_monsters__["a" /* ADD_MONSTERS */]:{return Object.assign({},state,action.monsters.reduce(function(acc,name){var deck=newDeck(__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["d" /* MONSTERS */][name].cards,false);acc[name]=Object.assign({},deck);return acc;},{}));}case __WEBPACK_IMPORTED_MODULE_2__actions_monsters__["b" /* REMOVE_MONSTER */]:{var newState=Object.assign({},state);delete newState[action.name];return newState;}case __WEBPACK_IMPORTED_MODULE_4__actions_boss__["b" /* SET_BOSS */]:{if(state['Boss']){return state;}var deck=newDeck(__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["a" /* BOSS_CARDS */],true);return Object.assign({},state,{Boss:Object.assign({},deck,_hasActiveCards(state,'Boss')&&revealNextCard(deck))});}case __WEBPACK_IMPORTED_MODULE_4__actions_boss__["a" /* REMOVE_BOSS */]:{var _newState=Object.assign({},state);delete _newState['Boss'];return _newState;}case REVEAL_CARDS:{return Object.keys(state).reduce(function(acc,name){var deck=state[name];acc[name]=Object.assign({},deck,deck.active&&revealNextCard(state[name]));return acc;},{});}case TOGGLE_ACTIVE:{var _deck=state[action.name];var _newDeck=Object.assign({},_deck,{active:!_deck.active},_deck.active?{currentCard:null}:_hasActiveCards(state,'TOGGLE_ACTIVE')&&revealNextCard(_deck));if(_newDeck.active&&_hasActiveCards(state,'TOGGLE_ACTIVE')){_newDeck=Object.assign({},_newDeck,revealNextCard(_deck));}else if(!_newDeck.active){_newDeck.currentCard=null;}return Object.assign({},state,_defineProperty({},action.name,_newDeck));}case __WEBPACK_IMPORTED_MODULE_5__actions_turn__["b" /* END_TURN */]:{return Object.keys(state).reduce(function(acc,name){var deck=state[name];acc[name]=Object.assign({},deck,Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["h" /* needsShuffle */])(deck)?shuffleDeck(deck):{currentCard:null});return acc;},{});}case __WEBPACK_IMPORTED_MODULE_5__actions_turn__["a" /* END_SCENARIO */]:{return defaultState;}default:return state;}};function revealNextCardsAction(dispatch){dispatch({type:REVEAL_CARDS});}function toggleActiveAction(dispatch,name){dispatch({type:TOGGLE_ACTIVE,name:name});}var selectors={hasActiveCards:function hasActiveCards(state){return _hasActiveCards(state.monsterDecks);},activeDecks:function activeDecks(state){var decks=state.monsterCards;return Object.keys(decks).reduce(function(acc,m){var deck=decks[m];if(deck.active){acc[m]=deck;}return acc;},{});}};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_BOSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOVE_BOSS; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setBossAction;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeBossAction;
var SET_BOSS="monsters/boss/set";var REMOVE_BOSS="monsters/boss/remove";function setBossAction(dispatch,name,level,numPlayers){dispatch({type:SET_BOSS,name:name,level:level,numPlayers:numPlayers});}function removeBossAction(dispatch){dispatch({type:REMOVE_BOSS});}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(75);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HEAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RETALIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPOUND_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return JUMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FLYING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PIERCE; });
/* unused harmony export PUSH */
/* unused harmony export PULL */
/* unused harmony export CURSE */
/* unused harmony export BLESS */
/* harmony export (immutable) */ __webpack_exports__["m"] = action;
/* harmony export (immutable) */ __webpack_exports__["n"] = iconForAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attack_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heal_svg__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__heal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__move_svg__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__move_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__move_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pierce_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__range_svg__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__range_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__range_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retaliate_svg__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retaliate_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__retaliate_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shield_svg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__target_svg__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loot_svg__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loot_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__push_svg__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__push_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__push_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pull_svg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pull_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pull_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__jump_svg__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__jump_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__jump_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flying_svg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flying_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__flying_svg__);
var _icons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ATTACK="Attack";var HEAL="Heal";var MOVE="Move";var RANGE="Range";var RETALIATE="Retaliate";var SHIELD="Shield";var TARGET="Target";var LOOT="Loot";var COMPOUND_TEXT="COMPOUND_TEXT";var JUMP="Jump";var FLYING="Flying";var PIERCE="PIERCE";var PUSH="PUSH";var PULL="PULL";var CURSE="CURSE";var BLESS="BLESS";function action(type,modifier,subActions,image){return{type:type,modifier:modifier,subActions:subActions||[],image:image};}var icons=(_icons={},_defineProperty(_icons,ATTACK,__WEBPACK_IMPORTED_MODULE_0__attack_svg___default.a),_defineProperty(_icons,HEAL,__WEBPACK_IMPORTED_MODULE_1__heal_svg___default.a),_defineProperty(_icons,MOVE,__WEBPACK_IMPORTED_MODULE_2__move_svg___default.a),_defineProperty(_icons,PIERCE,__WEBPACK_IMPORTED_MODULE_3__pierce_svg___default.a),_defineProperty(_icons,RANGE,__WEBPACK_IMPORTED_MODULE_4__range_svg___default.a),_defineProperty(_icons,RETALIATE,__WEBPACK_IMPORTED_MODULE_5__retaliate_svg___default.a),_defineProperty(_icons,SHIELD,__WEBPACK_IMPORTED_MODULE_6__shield_svg___default.a),_defineProperty(_icons,TARGET,__WEBPACK_IMPORTED_MODULE_7__target_svg___default.a),_defineProperty(_icons,LOOT,__WEBPACK_IMPORTED_MODULE_8__loot_svg___default.a),_defineProperty(_icons,PUSH,__WEBPACK_IMPORTED_MODULE_9__push_svg___default.a),_defineProperty(_icons,PULL,__WEBPACK_IMPORTED_MODULE_10__pull_svg___default.a),_defineProperty(_icons,JUMP,__WEBPACK_IMPORTED_MODULE_11__jump_svg___default.a),_defineProperty(_icons,FLYING,__WEBPACK_IMPORTED_MODULE_12__flying_svg___default.a),_icons);function iconForAction(actionName){return icons[actionName];}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MonsterStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actions_Actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_stats__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_icons__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MonsterStats_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MonsterStats_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MonsterStats_css__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function MonsterStats(_ref){var className=_ref.className,stats=_ref.stats,elite=_ref.elite;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__(_defineProperty({"MonsterTracker--Stats--Container":true,"MonsterTracker--Stats--Elite":elite},className,!!className))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--Main"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--MainLine"},stats.move===0?"-":stats.move,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["b" /* MOVEMENT */]),className:"MonsterTracker--StatIcon",alt:"movement"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--MainLine"},stats.attack===0?"-":stats.attack,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["a" /* ATTACK */]),className:"MonsterTracker--StatIcon",alt:"attack"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--MainLine"},stats.range===0?"-":stats.range,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["c" /* RANGE */]),className:"MonsterTracker--StatIcon",alt:"range"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--Extra"},stats.specialOne&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Special 1: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Actions_Actions__["a" /* Actions */],{actions:stats.specialOne})),stats.specialTwo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Special 2: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Actions_Actions__["a" /* Actions */],{actions:stats.specialTwo})),stats.extra&&stats.extra.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},typeof e==="string"?e:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Stats--ExtraLine"},e.type," ",e.modifier,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"MonsterTracker--StatIcon",src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_icons__["a" /* getIcon */])(e.type),alt:e.type})));})));}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusEffectTracker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusEffectTracker_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusEffectTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StatusEffectTracker_css__);
function StatusEffectTracker(_ref){var className=_ref.className,statusEffects=_ref.statusEffects,_ref$immunities=_ref.immunities,immunities=_ref$immunities===undefined?[]:_ref$immunities,onToggle=_ref.onToggle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("StatusEffects",className)},Object.keys(statusEffects).map(function(s){var active=statusEffects[s];var immune=immunities.includes(s);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:s,className:__WEBPACK_IMPORTED_MODULE_1_classnames__({"StatusEffect--Container":true,"StatusEffect--Immune":immune})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_statusEffects__["n" /* iconForStatusEffect */])(s),className:__WEBPACK_IMPORTED_MODULE_1_classnames__({"StatusEffect":true,"StatusEffect--Inactive":!active}),alt:s+" - "+(active?"active":"inactive"),onClick:function onClick(){!immune&&onToggle(s);}}));}));}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(60);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(65);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(74);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(32);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(81);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(95);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(94);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(88);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(41);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(20);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setStatusAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_turn__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=__WEBPACK_IMPORTED_MODULE_0__lib_elements__["e" /* ELEMENTS */].reduce(function(acc,e){acc[e]=__WEBPACK_IMPORTED_MODULE_0__lib_elements__["h" /* INERT */];return acc;},{});var SET_STATUS='elements/status/set';var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_party__["a" /* LOAD_PARTY */]:{return defaultState;}case SET_STATUS:{return Object.assign({},state,_defineProperty({},action.element,action.status));}case __WEBPACK_IMPORTED_MODULE_2__actions_turn__["b" /* END_TURN */]:{return Object.keys(state).reduce(function(acc,e){var _STRONG$WANING$INERT$;var status=state[e];acc[e]=(_STRONG$WANING$INERT$={},_defineProperty(_STRONG$WANING$INERT$,__WEBPACK_IMPORTED_MODULE_0__lib_elements__["j" /* STRONG */],__WEBPACK_IMPORTED_MODULE_0__lib_elements__["k" /* WANING */]),_defineProperty(_STRONG$WANING$INERT$,__WEBPACK_IMPORTED_MODULE_0__lib_elements__["k" /* WANING */],__WEBPACK_IMPORTED_MODULE_0__lib_elements__["h" /* INERT */]),_defineProperty(_STRONG$WANING$INERT$,__WEBPACK_IMPORTED_MODULE_0__lib_elements__["h" /* INERT */],__WEBPACK_IMPORTED_MODULE_0__lib_elements__["h" /* INERT */]),_STRONG$WANING$INERT$)[status];return acc;},{});}case __WEBPACK_IMPORTED_MODULE_2__actions_turn__["a" /* END_SCENARIO */]:{return defaultState;}default:return state;}};function setStatusAction(dispatch,element,status){dispatch({type:SET_STATUS,element:element,status:status});}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndTurnButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndTurnButton_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndTurnButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EndTurnButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EndTurnButton=function(_React$Component){_inherits(EndTurnButton,_React$Component);function EndTurnButton(props){_classCallCheck(this,EndTurnButton);// taken from https://github.com/reactjs/react-modal/tree/v3.1.11#examples
var _this=_possibleConstructorReturn(this,(EndTurnButton.__proto__||Object.getPrototypeOf(EndTurnButton)).call(this,props));_this.customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)'}};_this.state={showWarning:false};return _this;}_createClass(EndTurnButton,[{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,turn=_props.turn,endTurnReady=_props.endTurnReady,endTurn=_props.endTurn;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:className,onClick:function onClick(){if(!endTurnReady){_this2.setState({showWarning:true});return;}endTurn();}},turn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"\u7ED3\u675F\u56DE\u5408"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"(\u56DE\u5408\uFF1A ",turn,")")):"结束回合"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:this.state.showWarning,contentLabel:"End Turn",style:this.customStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Are you sure you want to end your turn?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"No monster cards have been flipped yet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"EndTurnButton--Modal--Buttons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.setState({showWarning:false});}},"No"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){_this2.setState({showWarning:false});endTurn();}},"Yes"))));}}]);return EndTurnButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = newPerksUsage;
/* harmony export (immutable) */ __webpack_exports__["d"] = perksForClass;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLASS_NAMES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getCharacterStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bonuses__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__statusEffects__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CardsModifier=function(){function CardsModifier(cards){_classCallCheck(this,CardsModifier);this._cards=cards;}_createClass(CardsModifier,[{key:"removeCards",value:function removeCards(count,card){var removedCount=0;this._cards=this._cards.filter(function(c){var keep=removedCount>=count||!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](c,card);if(!keep){removedCount++;}return keep;});return this;}},{key:"addCards",value:function addCards(count,card){this._cards=this._cards.concat(Array(count).fill(card));return this;}},{key:"cards",value:function cards(){return this._cards;}}]);return CardsModifier;}();var CLASSES={"Brute":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove two -1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add two +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one +3 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_THREE}).cards();}},{description:"Add three ROLLING PUSH 1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["q" /* push */](1),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING PIERCE 3 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["e" /* pierce */](3),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING DISARM card and one ROLLING MUDDLE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["c" /* DISARM */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING ADD TARGET card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +1 Shield 1, Self card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_2__bonuses__["f" /* shield */]("1")}).cards();}},{description:"Ignore negative item effects and add one +1 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}}]},"Cragheart":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one -2 card and two +2 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add one +2 MUDDLE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */]}).cards();}},{description:"Add two PUSH 2 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["q" /* push */](2)}).cards();}},{description:"Add two ROLLING EARTH cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING AIR cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative item effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}},{description:"Ignore negative dungeon effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Mindthief":{stats:[{maxHP:6},{maxHP:7},{maxHP:8},{maxHP:9},{maxHP:10},{maxHP:11},{maxHP:12},{maxHP:13},{maxHP:14}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace two +1 cards with two +2 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Replace one -2 card with one +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Add one +2 ICE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["g" /* ICE */]}).cards();}},{description:"Add two ROLLING +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add three ROLLING PULL 1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["p" /* pull */](1),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add three ROLLING MUDDLE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING IMMOBILIZE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING DISARM card and one ROLLING MUDDLE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["c" /* DISARM */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Scoundrel":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -2 card with one +0 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add two ROLLING +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING PIERCE 3 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["e" /* pierce */](3),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING POISON cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["g" /* POISON */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING MUDDLE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING INVISIBLE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["e" /* INVISIBLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Spellweaver":{stats:[{maxHP:6},{maxHP:7},{maxHP:8},{maxHP:9},{maxHP:10},{maxHP:11},{maxHP:12},{maxHP:13},{maxHP:14}],perks:[{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add two +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one +0 STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ZERO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */]}).cards();}},{description:"Add one +1 WOUND card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add one +1 CURSE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["b" /* CURSE */]}).cards();}},{description:"Add one +2 FIRE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */]}).cards();}},{description:"Add one +2 ICE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["g" /* ICE */]}).cards();}},{description:"Add one ROLLING EARTH and one ROLLING AIR card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING LIGHT and one ROLLING DARK card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["i" /* LIGHT */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["c" /* DARK */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}}]},"Tinkerer":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace one -2 card with one +0 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one +3 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_THREE}).cards();}},{description:"Add two ROLLING FIRE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add three ROLLING MUDDLE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +1 WOUND card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add one +1 Heal 2 self card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+2")}).cards();}},{description:"Add one +0 ADD TARGET card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */]}).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Sun":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -2 card with one +0 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add two ROLLING +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING Heal 1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING LIGHT cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["i" /* LIGHT */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING Shield 1, Self cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["f" /* shield */]("1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative item effects and add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Three Spears":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add two ROLLING +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add three ROLLING MUDDLE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING PIERCE 3 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["e" /* pierce */](3),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING ADD TARGET card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +0 Refresh an item card",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["b" /* REFRESH_ITEM */]}).cards();}},{description:"Ignore negative item effects and add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}}]},"Concentric Circles":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace one -2 card with one +0 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add two ROLLING WOUND cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING POISON cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["g" /* POISON */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING Heal 1 cards",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING FIRE card and one ROLLING AIR card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING DARK card and one ROLLING EARTH card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["c" /* DARK */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative item effects and add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}}]},"Moon/Eclipse":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Add one -1 DARK card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].MINUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["c" /* DARK */]}).cards();}},{description:"Replace one -1 DARK card with one +1 DARK card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].MINUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["c" /* DARK */]}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["c" /* DARK */]}).cards();}},{description:"Add one +1 INVISIBLE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["e" /* INVISIBLE */]}).cards();}},{description:"Add three ROLLING MUDDLE cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING Heal 1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING CURSE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["b" /* CURSE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING ADD TARGET card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative scenario effects and add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}}]},"Cthulhu":{stats:[{maxHP:6},{maxHP:7},{maxHP:8},{maxHP:9},{maxHP:10},{maxHP:11},{maxHP:12},{maxHP:13},{maxHP:14}],perks:[{description:"Replace one -2 card with one +0 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add two +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add one +1 AIR card",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */]}).cards();}},{description:"Add three ROLLING POISON cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["g" /* POISON */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING CURSE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["b" /* CURSE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING IMMOBILIZE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative item effects and add one +1 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}}]},"Lightning Bolt":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove two -1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Replace one +0 card with one ROLLING +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING WOUND cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING +1 DISARM card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["c" /* DISARM */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING Heal 1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +2 FIRE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */]}).cards();}},{description:"Ignore negative item effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Music Note":{stats:[{maxHP:6},{maxHP:7},{maxHP:8},{maxHP:9},{maxHP:10},{maxHP:11},{maxHP:12},{maxHP:13},{maxHP:14}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove one -2 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_TWO).cards();}},{description:"Replace two +1 cards with one +4 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_FOUR}).cards();}},{description:"Replace one +0 card with one +1 IMMOBILIZE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Replace one +0 card with one +1 DISARM card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["c" /* DISARM */]}).cards();}},{description:"Replace one +0 card with one +2 WOUND card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Replace one +0 card with one +2 POISON card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["g" /* POISON */]}).cards();}},{description:"Replace one +0 card with one +2 CURSE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["b" /* CURSE */]}).cards();}},{description:"Replace one +0 card with one +3 MUDDLE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_THREE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */]}).cards();}},{description:"Replace one -1 card with one +0 STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ZERO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */]}).cards();}},{description:"Add three ROLLING +1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING CURSE cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["b" /* CURSE */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}}]},"Angry Face":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace two +0 cards with two +1 cards",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Add two ROLLING +1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +2 MUDDLE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["f" /* MUDDLE */]}).cards();}},{description:"Add one +1 POISON card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["g" /* POISON */]}).cards();}},{description:"Add one +1 WOUND card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add one +0 STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ZERO,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */]}).cards();}},{description:"Add one ROLLING ADD TARGET card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]},"Saw":{stats:[{maxHP:8},{maxHP:9},{maxHP:11},{maxHP:12},{maxHP:14},{maxHP:15},{maxHP:17},{maxHP:18},{maxHP:20}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Remove four +0 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(4,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add one ROLLING +2 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_TWO,endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add two ROLLING WOUND card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one ROLLING Heal 3 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+3"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add one +0 Refresh an item card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["b" /* REFRESH_ITEM */]}).cards();}}]},"Triforce":{stats:[{maxHP:6},{maxHP:7},{maxHP:8},{maxHP:9},{maxHP:10},{maxHP:11},{maxHP:12},{maxHP:13},{maxHP:14}],perks:[{description:"Remove two -1 cards",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add three +0 FIRE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */]}).cards();}},{description:"Add three +0 ICE cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["g" /* ICE */]}).cards();}},{description:"Add three +0 AIR cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */]}).cards();}},{description:"Add three +0 EARTH cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(3,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */]}).cards();}},{description:"Replace two +0 cards with one +0 FIRE and one +0 EARTH card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["f" /* FIRE */]}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */]}).cards();}},{description:"Replace two +0 cards with one +0 ICE and one +0 AIR card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["g" /* ICE */]}).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["a" /* AIR */]}).cards();}},{description:"Add two +1 PUSH 1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["q" /* push */](1)}).cards();}},{description:"Add one +1 WOUND card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Add one +0 STUN card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["l" /* STUN */]}).cards();}},{description:"Add one +0 ADD TARGET card",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["a" /* ADD_TARGET */]}).cards();}}]},"Two-Minis":{stats:[{maxHP:10},{maxHP:12},{maxHP:14},{maxHP:16},{maxHP:18},{maxHP:20},{maxHP:22},{maxHP:24},{maxHP:26}],perks:[{description:"Remove two -1 cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(2,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).cards();}},{description:"Replace one -1 card with one +1 card",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].MINUS_ONE).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ONE).cards();}},{description:"Replace one +0 card with one +2 card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).removeCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_ZERO).addCards(1,__WEBPACK_IMPORTED_MODULE_1__cards__["a" /* BASE_CARDS */].PLUS_TWO).cards();}},{description:"Add one +1 WOUND card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["m" /* WOUND */]}).cards();}},{description:"Add one +1 IMMOBILIZE card",maxPerkCount:2,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(1,{modifier:__WEBPACK_IMPORTED_MODULE_1__cards__["f" /* NUMBER_MODIFIERS */].PLUS_ONE,extra:__WEBPACK_IMPORTED_MODULE_4__statusEffects__["d" /* IMMOBILIZE */]}).cards();}},{description:"Add two ROLLING Heal 1 cards",maxPerkCount:3,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_2__bonuses__["c" /* heal */]("+1"),endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Add two ROLLING EARTH cards",maxPerkCount:1,modifyCards:function modifyCards(cards){return new CardsModifier(cards).addCards(2,{modifier:__WEBPACK_IMPORTED_MODULE_3__elements__["d" /* EARTH */],endAction:__WEBPACK_IMPORTED_MODULE_1__cards__["e" /* END_ACTIONS */].ROLLING}).cards();}},{description:"Ignore negative scenario effects",maxPerkCount:1,modifyCards:function modifyCards(cards){return cards;}}]}};function newPerksUsage(characterClass){var classData=CLASSES[characterClass];if(!classData){return null;}return classData.perks.map(function(p){return new Array(p.maxPerkCount).fill(false);});}function perksForClass(characterClass){var classData=CLASSES[characterClass];if(!classData){return null;}return classData.perks;}var CLASS_NAMES=Object.keys(CLASSES);function getCharacterStats(className,level){return CLASSES[className].stats[level];}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HEAL */
/* unused harmony export RETALIATE */
/* unused harmony export SHIELD */
/* unused harmony export PIERCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REFRESH_ITEM; });
/* unused harmony export BONUSES */
/* harmony export (immutable) */ __webpack_exports__["d"] = iconForBonus;
/* harmony export (immutable) */ __webpack_exports__["e"] = pierce;
/* harmony export (immutable) */ __webpack_exports__["f"] = shield;
/* harmony export (immutable) */ __webpack_exports__["c"] = heal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heal_svg__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__heal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__retaliate_svg__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__retaliate_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__retaliate_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shield_svg__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pierce_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__add_target_svg__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__add_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__add_target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__refresh_item_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__refresh_item_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__refresh_item_svg__);
var _bonusIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var HEAL="heal";var RETALIATE="retaliate";var SHIELD="shield";var PIERCE="pierce";var ADD_TARGET="add_target";var REFRESH_ITEM="refresh_item";var bonusIcons=(_bonusIcons={},_defineProperty(_bonusIcons,HEAL,__WEBPACK_IMPORTED_MODULE_0__heal_svg___default.a),_defineProperty(_bonusIcons,RETALIATE,__WEBPACK_IMPORTED_MODULE_1__retaliate_svg___default.a),_defineProperty(_bonusIcons,SHIELD,__WEBPACK_IMPORTED_MODULE_2__shield_svg___default.a),_defineProperty(_bonusIcons,PIERCE,__WEBPACK_IMPORTED_MODULE_3__pierce_svg___default.a),_defineProperty(_bonusIcons,ADD_TARGET,__WEBPACK_IMPORTED_MODULE_4__add_target_svg___default.a),_defineProperty(_bonusIcons,REFRESH_ITEM,__WEBPACK_IMPORTED_MODULE_5__refresh_item_svg___default.a),_bonusIcons);var BONUSES=Object.keys(bonusIcons);function iconForBonus(name){return bonusIcons[name];}function pierce(value){return{type:PIERCE,value:value};}function shield(value){var self=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return{type:SHIELD,value:value,self:self};}function heal(value){var self=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return{type:HEAL,value:value,self:self};}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HPTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HPTracker_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HPTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HPTracker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HPTracker=function(_React$Component){_inherits(HPTracker,_React$Component);function HPTracker(props){_classCallCheck(this,HPTracker);var _this=_possibleConstructorReturn(this,(HPTracker.__proto__||Object.getPrototypeOf(HPTracker)).call(this,props));_this.changeHPFinish=function(){return _this._changeHPFinish();};_this.state={hp:props.maxHP};return _this;}_createClass(HPTracker,[{key:"changeHP",value:function changeHP(hp){// if clicking... this.setState({hp: hp <= this.state.hp ? hp - 1 : hp});
this.setState({hp:hp});console.log('HPTracker changeHP',this.state,this.props,hp);}},{key:"changeHPStart",value:function changeHPStart(hp){document.addEventListener('mouseup',this.changeHPFinish,false);}},{key:"_changeHPFinish",value:function _changeHPFinish(){document.removeEventListener('mouseup',this.changeHPFinish,false);this.props.onHPChange(this.state.hp);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,maxHP=_props.maxHP;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("HPTracker--Container",className)},maxHP>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"HPTracker--Bars"},new Array(maxHP).fill().map(function(_,i){var hp=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:hp,className:__WEBPACK_IMPORTED_MODULE_1_classnames__({"HPTracker--HP":true,"HPTracker--HP--Active":hp<=_this2.state.hp,"HPTracker--HP--White":_this2.props.white}),onMouseDown:function onMouseDown(){_this2.changeHP(hp);_this2.changeHPStart(hp);},onMouseOver:function onMouseOver(event){// left mouse button
// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
if(event.buttons%2===1){_this2.changeHP(hp);}}},hp);})));}}]);return HPTracker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Actions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_icons__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_actions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Actions_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Actions_css__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function ActionModifier(_ref){var action=_ref.action,isSubAction=_ref.isSubAction,isBoss=_ref.isBoss,stats=_ref.stats;var statModifier=null;if(!isBoss&&stats&&action.modifier&&action.modifier.match(/^(\+|-)\d+/)){statModifier=parseInt(action.modifier,10);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,action.type,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__({"ActionModifier--Icon":true,"ActionModifier--SubAction--Icon":isSubAction}),src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])(action.type),alt:action.type}),statModifier!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,stats.normal[action.type.toLowerCase()]+statModifier," / ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"ActionModifier--stats--elite"},stats.elite[action.type.toLowerCase()]+statModifier)):action.modifier);}function Action(_ref2){var className=_ref2.className,action=_ref2.action,isSubAction=_ref2.isSubAction,isBoss=_ref2.isBoss,stats=_ref2.stats;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__(_defineProperty({"Card--Action":true,"Card--SubAction":isSubAction},className,className))},typeof action==="string"&&action,action.type===__WEBPACK_IMPORTED_MODULE_4__lib_actions__["b" /* COMPOUND_TEXT */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,action.modifier.map(function(t,i){var content=t;if(t.type){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Action,{key:i,className:"Card--Action--inline",action:t,isSubAction:isSubAction,isBoss:isBoss,stats:stats});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:i},content);})),action.type&&action.type!==__WEBPACK_IMPORTED_MODULE_4__lib_actions__["b" /* COMPOUND_TEXT */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionModifier,{action:action,isSubAction:isSubAction,isBoss:isBoss,stats:stats}),action.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"Card--Image",src:action.image,alt:"extra info for card"}));}function Actions(_ref3){var className=_ref3.className,actions=_ref3.actions,isBoss=_ref3.isBoss,stats=_ref3.stats;//console.log(actions);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className},actions.map(function(a,i){if(a.type==="element"){// use element
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Card--ElementUsage",key:i},a.use&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("Card--Element","Card--Element--Used")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("Card--Element","Card--Element--Icon","Card--Element--UsedElement"),src:__WEBPACK_IMPORTED_MODULE_3__lib_elements__["l" /* iconForElement */](a.use),alt:"use element"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("Card--Element","Card--Element--Icon","Card--Element--UsedOverlay"),src:__WEBPACK_IMPORTED_MODULE_3__lib_elements__["m" /* useElementIcon */],alt:"use element"})),a.use&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Card--Element--Separator"},":"),a.action&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Action,{action:a.action,isBoss:isBoss,stats:stats}),a.action.subActions&&a.action.subActions.map(function(sa,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Action,{key:j,action:sa,isSubAction:true});})),a.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"Card--Image",src:a.image,alt:"extra info for card"}),a.create&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Card--Element"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:__WEBPACK_IMPORTED_MODULE_1_classnames__("Card--Element","Card--Element--Icon"),src:__WEBPACK_IMPORTED_MODULE_3__lib_elements__["l" /* iconForElement */](a.create),alt:"use element"})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Action--Section",key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Action,{action:a,isBoss:isBoss,stats:stats}),a.subActions&&a.subActions.map(function(sa,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Action,{key:j,action:sa,isSubAction:true,isBoss:isBoss,stats:stats});}));}));}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bonuses__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_index__ = __webpack_require__(24);
function getIcon(name){return Object(__WEBPACK_IMPORTED_MODULE_0__elements__["l" /* iconForElement */])(name)||Object(__WEBPACK_IMPORTED_MODULE_2__statusEffects__["n" /* iconForStatusEffect */])(name)||Object(__WEBPACK_IMPORTED_MODULE_1__bonuses__["d" /* iconForBonus */])(name)||Object(__WEBPACK_IMPORTED_MODULE_3__actions_index__["n" /* iconForAction */])(name);}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Card;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actions_Actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_cards__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Card_css__);
function Card(_ref){var className=_ref.className,name=_ref.name,card=_ref.card,stats=_ref.stats;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monster--Card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monster--Card--Name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monster--Card--Initiative"},card.initiative),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Actions_Actions__["a" /* Actions */],{className:"Monster--Card--Actions",actions:card.actions,isBoss:name==="Boss",stats:stats}),card.endAction&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"Monster--Card--EndAction",src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_cards__["g" /* iconForEndAction */])(card.endAction),alt:card.endAction}));}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HPTrackerFunction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HPTracker_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HPTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HPTracker_css__);
function HPTrackerFunction(_ref){var monsterData=_ref.monsterData;var monster=monsterData;var maxHP=monster.maxHP;var currentHP=monster.currentHP;// console.log('HPTrackerFunction', monsterData);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames__('HPTracker--Container')},maxHP>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HPTracker--Bars'},new Array(maxHP).fill().map(function(_,i){var hp=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:hp,className:__WEBPACK_IMPORTED_MODULE_1_classnames__({'HPTracker--HP':true,'HPTracker--HP--Active':hp<=currentHP,'HPTracker--HP--White':false})},hp);})));}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/damage-1.3e3acaf7.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/damage-5.aa5ebddb.png";

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony export (immutable) */ __webpack_exports__["a"] = dealDamageAction;
/* unused harmony export selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_boss__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_monsters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_turn__ = __webpack_require__(2);
function newBoss(name,level,numPlayers){var stats=__WEBPACK_IMPORTED_MODULE_1__lib_monsters__["c" /* BOSS_STATS */][name][level](numPlayers);return{name:name,maxHP:stats.maxHP,currentHP:stats.maxHP,statusEffects:__WEBPACK_IMPORTED_MODULE_0__lib_statusEffects__["j" /* STATUS_EFFECTS */].reduce(function(acc,s){acc[s]=false;return acc;},{})};}var defaultState=null;var DEAL_DAMAGE='boss/hp/damage';var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions_party__["a" /* LOAD_PARTY */]:{return defaultState;}case __WEBPACK_IMPORTED_MODULE_4__actions_monsters__["c" /* RESET_MONSTERS */]:{return defaultState;}case __WEBPACK_IMPORTED_MODULE_3__actions_boss__["b" /* SET_BOSS */]:{if(action.name==='Inox Bodyguard'){return[newBoss(action.name,action.level,action.numPlayers),newBoss(action.name,action.level,action.numPlayers)];}return[newBoss(action.name,action.level,action.numPlayers)];}case __WEBPACK_IMPORTED_MODULE_3__actions_boss__["a" /* REMOVE_BOSS */]:{return defaultState;}case DEAL_DAMAGE:{var boss=state[action.index];var currentHP=boss.currentHP-action.damage;if(currentHP>boss.maxHP){return state;}if(currentHP>0){boss.currentHP=currentHP;if(state.length===1){return[boss];}else{if(action.index===0){return[boss,state[1]];}else{return[state[0],boss];}}}else{if(state.length===2){return[state[1-action.index]];}else{action.asyncDispatch({type:"monsters/boss/remove"});return defaultState;}}}case __WEBPACK_IMPORTED_MODULE_5__actions_turn__["a" /* END_SCENARIO */]:{return defaultState;}default:return state;}};function dealDamageAction(dispatch,index,damage){dispatch({type:DEAL_DAMAGE,index:index,damage:damage});}var selectors={};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(58);
module.exports = __webpack_require__(63);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(59).enable();
  window.Promise = __webpack_require__(61);
}

// fetch() polyfill for making API calls.
__webpack_require__(62);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(18);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(27);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(27);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
// import registerServiceWorker from './registerServiceWorker';
__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement("#root");Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */],null)),document.getElementById('root'));//registerServiceWorker();
Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(18),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(18),q=__webpack_require__(66);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(67);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(71);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(30);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(19);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(77);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(70);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(72);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(73);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(30);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(76);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(19);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(29);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(29);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(20);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(34);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(104);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(40);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(91);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(89);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(37);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(93);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(97);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(96)(module)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(38);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(40);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(41);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(105);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(20);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/gloomhaven",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/gloomhaven"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Game__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Game__["a" /* Game */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Game; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_Header__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PartyManager__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Monsters_ListModal__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Players_PlayerTrackers__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Monsters_MonsterDecks__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Monsters_MonsterTrackers__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_actions_players__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header_EndTurnButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_actions_turn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_monsterDecks__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_simple_storage__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_simple_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_simple_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Game_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Game_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Game_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { List as MonsterList } from './Monsters/List';
var GameComponent=function(_React$Component){_inherits(GameComponent,_React$Component);_createClass(GameComponent,null,[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){return null;}}]);function GameComponent(props){_classCallCheck(this,GameComponent);var _this=_possibleConstructorReturn(this,(GameComponent.__proto__||Object.getPrototypeOf(GameComponent)).call(this,props));_this.state={playerNameInput:'',selectedClass:'',duplicateNameWarning:false,showSections:{players:true,monsterList:true,monsterDecks:true,monsters:true},showStats:true,showMonstersListModal:false,hasMonstersInPlay:false};// console.log('GameComponent', this.state);
return _this;}_createClass(GameComponent,[{key:'toggleSection',value:function toggleSection(section){this.setState({showSections:Object.assign({},this.state.showSections,_defineProperty({},section,!this.state.showSections[section]))});}},{key:'handleHasActiveCardsChanged',value:function handleHasActiveCardsChanged(hasActiveCardsChanged){console.log('handleHasActiveCardsChanged',hasActiveCardsChanged);}},{key:'toggleMonstersListModal',value:function toggleMonstersListModal(showMonstersListModal){this.setState({showMonstersListModal:showMonstersListModal});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,decks=_props.decks,hasActiveCards=_props.hasActiveCards,hasMonstersAlive=_props.hasMonstersAlive,revealNextCards=_props.revealNextCards,_endTurn=_props.endTurn;var deckNames=Object.keys(decks);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_simple_storage___default.a,{parent:this,prefix:'Gloomhaven_Data'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header_Header__["a" /* Header */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--leftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--Section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Monsters',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'Game--MonsterList--Button',onClick:function onClick(){return _this2.toggleMonstersListModal(!_this2.state.showMonstersListModal);},disabled:this.props.numPlayers===0},'Add Monsters'),this.state.showMonstersListModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Monsters_ListModal__["a" /* ListModal */],{name:this.props.name,onClose:function onClose(){return _this2.toggleMonstersListModal(false);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'Game--Section--hideSection':!this.state.showSections.monsters})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Monsters_MonsterTrackers__["a" /* MonsterTrackers */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--rightSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--Section Monster-Cards-Section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Monster Cards',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'MonsterDecks--Header--Button',disabled:!deckNames.some(function(m){return decks[m].active;})||hasActiveCards,onClick:function onClick(){return revealNextCards(deckNames);}},'\u7FFB\u602A\u7269\u884C\u52A8\u5361'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Header_EndTurnButton__["a" /* EndTurnButton */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'MonsterDecks--Header--Button':true,'MonsterDecks--Header--ButtonReady':hasActiveCards}),endTurnReady:hasActiveCards||!hasMonstersAlive,endTurn:function endTurn(){return _endTurn();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'Game--Section--hideSection':!this.state.showSections.monsterDecks})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Monsters_MonsterDecks__["a" /* MonsterDecks */],{showStats:false,showTimeline:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Game--Section Players-Section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'Game--Section--Toggle',onClick:function onClick(){return _this2.toggleSection('players');}},'Players',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Game--Section--ToggleSymbol'},this.state.showSections.players?'▾':'▸')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'Game--Section--hideSection':!this.state.showSections.players})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PartyManager__["a" /* PartyManager */],null),!this.state.hasMonstersInPlay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Players_PlayerTrackers__["a" /* PlayerTrackers */],null))))));}}]);return GameComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Game=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{selectableClasses:__WEBPACK_IMPORTED_MODULE_9__store_players__["b" /* selectors */].selectableClasses(state),playerNames:Object.keys(state.players.players),hasMonstersInPlay:__WEBPACK_IMPORTED_MODULE_10__store_monsters__["c" /* selectors */].hasMonstersInPlay(state),hasMonstersAlive:__WEBPACK_IMPORTED_MODULE_10__store_monsters__["c" /* selectors */].hasMonstersAlive(state),decks:state.monsterDecks,hasActiveCards:__WEBPACK_IMPORTED_MODULE_14__store_monsterDecks__["c" /* selectors */].hasActiveCards(state),numPlayers:__WEBPACK_IMPORTED_MODULE_9__store_players__["b" /* selectors */].numPlayers(state)};},function(dispatch,ownProps){return{addPlayer:function addPlayer(name,characterClass){return Object(__WEBPACK_IMPORTED_MODULE_11__store_actions_players__["c" /* addPlayerAction */])(dispatch,name,characterClass,0);},endTurn:function endTurn(){return Object(__WEBPACK_IMPORTED_MODULE_13__store_actions_turn__["d" /* endTurnAction */])(dispatch);},revealNextCards:function revealNextCards(){Object(__WEBPACK_IMPORTED_MODULE_14__store_monsterDecks__["b" /* revealNextCardsAction */])(dispatch);}};})(GameComponent);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementTracker_ElementTracker__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EndTurnButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EndScenarioButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_turn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_monsterDecks__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Header_css__);
function HeaderComponent(_ref){var turn=_ref.turn,hasActiveCards=_ref.hasActiveCards,endTurnReady=_ref.endTurnReady,_endTurn=_ref.endTurn,_endScenario=_ref.endScenario;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Header--Content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ElementTracker_ElementTracker__["a" /* ElementTracker */],{className:'Header--Content--Section'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EndTurnButton__["a" /* EndTurnButton */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'Header--EndTurnButton':true,'Header--EndTurnButton--Ready':hasActiveCards}),turn:turn,endTurnReady:endTurnReady,endTurn:function endTurn(){return _endTurn();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EndScenarioButton__["a" /* EndScenarioButton */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'Header--EndScenarioButton':true}),endScenario:function endScenario(){return _endScenario();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Header--HeightOffset'}));}var Header=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{hasActiveCards:__WEBPACK_IMPORTED_MODULE_7__store_monsterDecks__["c" /* selectors */].hasActiveCards(state),endTurnReady:__WEBPACK_IMPORTED_MODULE_7__store_monsterDecks__["c" /* selectors */].hasActiveCards(state)||!__WEBPACK_IMPORTED_MODULE_8__store_monsters__["c" /* selectors */].hasMonstersAlive(state),turn:state.turn};},function(dispatch){return{endTurn:function endTurn(){return Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_turn__["d" /* endTurnAction */])(dispatch);},endScenario:function endScenario(){return Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_turn__["c" /* endScenarioAction */])(dispatch);}};})(HeaderComponent);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ElementTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_elements__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_elements__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementTracker_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ElementTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ElementTracker_css__);
var _borderClassNameForSt,_classNameForStatus;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var borderClassNameForStatus=(_borderClassNameForSt={},_defineProperty(_borderClassNameForSt,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["h" /* INERT */],"ElementTracker--Element--BorderInert"),_defineProperty(_borderClassNameForSt,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["k" /* WANING */],"ElementTracker--Element--BorderWaning"),_defineProperty(_borderClassNameForSt,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["j" /* STRONG */],"ElementTracker--Element--BorderStrong"),_borderClassNameForSt);var classNameForStatus=(_classNameForStatus={},_defineProperty(_classNameForStatus,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["h" /* INERT */],"ElementTracker--Element--Inert"),_defineProperty(_classNameForStatus,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["k" /* WANING */],"ElementTracker--Element--Waning"),_defineProperty(_classNameForStatus,__WEBPACK_IMPORTED_MODULE_3__lib_elements__["j" /* STRONG */],"ElementTracker--Element--Strong"),_classNameForStatus);/*
function Elements({className, elements, status, onClick}) {
    return (<div className="ElementTracker--Column">
        {status}
        {ELEMENTS.map((e, i) => {
            const activeClass = (elements[e] === status) && "ElementTracker--Element--Active";
            return (<img key={i}
                className={classNames("ElementTracker--Element", activeClass)}
                src={iconForElement(e)}
                onClick={() => onClick(e, status)}
                alt={e}
            />)
        })}
    </div>);
}
*/function ElementTrackerComponent(_ref){var className=_ref.className,elements=_ref.elements,setElementStatus=_ref.setElementStatus;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_2_classnames__("ElementTracker",className)},__WEBPACK_IMPORTED_MODULE_3__lib_elements__["e" /* ELEMENTS */].map(function(e){var status=elements[e];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:e,className:"ElementTracker--Column"},[__WEBPACK_IMPORTED_MODULE_3__lib_elements__["h" /* INERT */],__WEBPACK_IMPORTED_MODULE_3__lib_elements__["k" /* WANING */],__WEBPACK_IMPORTED_MODULE_3__lib_elements__["j" /* STRONG */]].map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:s,className:__WEBPACK_IMPORTED_MODULE_2_classnames__(_defineProperty({"ElementTracker--Element":true,"ElementTracker--ElementContainer":true,"ElementTracker--Element--Border":true},borderClassNameForStatus[s],status===s))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:__WEBPACK_IMPORTED_MODULE_2_classnames__(_defineProperty({"ElementTracker--Element":true,"ElementTracker--Element--Inactive":true},classNameForStatus[s],status===s)),src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_elements__["l" /* iconForElement */])(e),onClick:function onClick(){return setElementStatus(e,s);},alt:e+" - "+status}));}));}));}var ElementTracker=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{elements:state.elements};},function(dispatch){return{setElementStatus:function setElementStatus(element,status){return Object(__WEBPACK_IMPORTED_MODULE_4__store_elements__["b" /* setStatusAction */])(dispatch,element,status);}};})(ElementTrackerComponent);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/any_element.3687221d.svg";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/air.b71a1e90.svg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dark.89ef21f6.svg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/earth.11e7c60d.svg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fire.d45dc737.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ice.a5af5486.svg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/light.fea53de9.svg";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/use_element.ed829f9b.svg";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndScenarioButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndScenarioButton_css__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndScenarioButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EndScenarioButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EndScenarioButton=function(_React$Component){_inherits(EndScenarioButton,_React$Component);function EndScenarioButton(props){_classCallCheck(this,EndScenarioButton);// taken from https://github.com/reactjs/react-modal/tree/v3.1.11#examples
var _this=_possibleConstructorReturn(this,(EndScenarioButton.__proto__||Object.getPrototypeOf(EndScenarioButton)).call(this,props));_this.customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)'}};_this.state={showWarning:false};return _this;}_createClass(EndScenarioButton,[{key:'render',value:function render(){var _this2=this;var _props=this.props,className=_props.className,endScenarioReady=_props.endScenarioReady,endScenario=_props.endScenario;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:className,onClick:function onClick(){if(!endScenarioReady){_this2.setState({showWarning:true});return;}endScenario();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\u7ED3\u675F\u5267\u672C'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:this.state.showWarning,contentLabel:'End Scenario',style:this.customStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Are you sure you want to end this scenario?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'EndScenarioButton--Modal--Button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.setState({showWarning:false});}},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){_this2.setState({showWarning:false});endScenario();}},'Yes'))));}}]);return EndScenarioButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shuffle.02b9993d.svg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rolling.09ae61fc.svg";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle.80bf6532.svg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle-with-middle-black.41cc1fc8.svg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle-with-side-black.57e14188.svg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-2.ee68e6ed.svg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-2-with-black.ada60566.svg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-3-with-corner-black.46c07040.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-3-with-black.3bf93453.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-4-with-black.336025e6.svg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-6-with-black.1cba71ae.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-4-with-black.66d11fbc.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elderDrakeSpecial1Area.eb3b491a.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxBodyguardSpecial1Area.42a2a477.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sightlessEyeSpecial1Area.83d99185.svg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sightlessEyeSpecial2Area.b39dba33.svg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/curse.5fbb8b2f.svg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bless.c9e17e32.svg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/disarm.14c767e8.svg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/immobilize.06a7bf04.svg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/invisible.6aaa5c90.svg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/muddle.0265827a.svg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poison.57e3c705.svg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/strengthen.ee72246f.svg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stun.9dfae759.svg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wound.b07b0aea.svg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/regenerate.95d59379.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/push.6109e085.svg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pull.ed1cbec6.svg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attack.79852f29.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heal.7e43977c.svg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/move.bea37385.svg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pierce.904bbb03.svg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/range.786732e0.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/retaliate.e0cc69e5.svg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shield.859b3baa.svg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/target.cb5d81e7.svg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loot.bddb0267.svg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/push.6109e085.svg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pull.ed1cbec6.svg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jump.df5dd13a.svg";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flying.643cca37.svg";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartyManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PartyManagerComponent=function(_React$Component){_inherits(PartyManagerComponent,_React$Component);function PartyManagerComponent(props){_classCallCheck(this,PartyManagerComponent);var _this=_possibleConstructorReturn(this,(PartyManagerComponent.__proto__||Object.getPrototypeOf(PartyManagerComponent)).call(this,props));_this.state={savedData:JSON.parse(localStorage.getItem('party')),partyNameInput:'',selectedParty:''};// console.log('PartyManagerComponent', this.props);
return _this;}_createClass(PartyManagerComponent,[{key:'saveParty',value:function saveParty(){var _this2=this;console.log('saveParty this.props',this.props);var partyData=Object.entries(this.props.players).reduce(function(acc,_ref){var _ref2=_slicedToArray(_ref,2),playerName=_ref2[0],player=_ref2[1];console.log('saveParty player',player);var deck=_this2.props.attackModifierDecks[playerName];acc[playerName]={name:playerName,class:player.class,level:player.level,perkUsage:deck.perkUsage,minusOneCards:deck.minusOneCards,xp:player.xp};return acc;},{});var monstersData=Object.entries(this.props.monsters).reduce(function(acc,_ref3){var _ref4=_slicedToArray(_ref3,2),monsterName=_ref4[0],monsters=_ref4[1];console.log('saveParty monsters',monsters);acc[monsterName]=monsters;return acc;},{});var partyName=this.state.partyNameInput+' - '+new Date().toLocaleDateString();var newSavedData=Object.assign({},this.state.savedData,_defineProperty({},partyName,[partyData,monstersData]));console.log('saveParty newSavedData',newSavedData);localStorage.setItem('party',JSON.stringify(newSavedData));this.setState({savedData:newSavedData,selectedParty:this.state.selectedParty?this.state.selectedParty:partyName});}},{key:'selectParty',value:function selectParty(selectedParty){this.setState({selectedParty:selectedParty});}},{key:'loadParty',value:function loadParty(){this.setState({partyNameInput:this.state.selectedParty.split(' - ')[0]});this.props.loadParty(this.state.savedData[this.state.selectedParty]);}},{key:'deleteParty',value:function deleteParty(){var newSavedData=Object.assign({},this.state.savedData);delete newSavedData[this.state.selectedParty];localStorage.setItem('party',JSON.stringify(newSavedData));this.setState({savedData:newSavedData,selectedParty:''});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PartyManager--section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'\u56E2\u961F\u540D\u79F0',value:this.state.partyNameInput,onChange:function onChange(e){return _this3.setState({partyNameInput:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.saveParty();}},'\u4FDD\u5B58\u56E2\u961F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.selectedParty,onChange:function onChange(event){return _this3.selectParty(event.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'\u9009\u62E9\u4E00\u4E2A\u56E2\u961F'),this.state.savedData&&Object.keys(this.state.savedData).map(function(partyName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:partyName,key:partyName},partyName);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.state.selectedParty,onClick:function onClick(){return _this3.loadParty();}},'\u8BFB\u53D6\u56E2\u961F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.state.selectedParty,onClick:function onClick(){return _this3.deleteParty();}},'\u5220\u9664\u56E2\u961F')));}}]);return PartyManagerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var PartyManager=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{players:state.players.players,attackModifierDecks:state.attackModifierDecks,monsters:state.monsters.monsters,monsterDecks:state.monsterDecks};},function(dispatch){return{loadParty:function loadParty(party){return Object(__WEBPACK_IMPORTED_MODULE_2__store_actions_party__["b" /* loadPartyAction */])(dispatch,party);}};})(PartyManagerComponent);

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_monsters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_boss__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListModal_css__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ListModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListModalComponent=function(_React$Component){_inherits(ListModalComponent,_React$Component);function ListModalComponent(props){_classCallCheck(this,ListModalComponent);var _this=_possibleConstructorReturn(this,(ListModalComponent.__proto__||Object.getPrototypeOf(ListModalComponent)).call(this,props));_this._updateDimensions=function(){_this.setState({windowHeight:document.documentElement.clientHeight});};_this.customStyles={content:{top:'60px',left:'100px',right:'auto',bottom:'10px',padding:'10px 20px',overflowY:'hidden'}};_this.state={selectedMonsters:[],selectedBoss:__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["b" /* BOSS_LIST */][0],windowHeight:document.documentElement.clientHeight};return _this;}_createClass(ListModalComponent,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this._updateDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this._updateDimensions);}},{key:'selectBoss',value:function selectBoss(boss){this.setState({selectedBoss:boss});}},{key:'handleMonsterSelection',value:function handleMonsterSelection(options){var selectedMonsters=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=options[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var o=_step.value;if(o.selected){selectedMonsters.push(o.value);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}this.setState({selectedMonsters:selectedMonsters});}},{key:'onMonsterSelectionDblClick',value:function onMonsterSelectionDblClick(){this.props.addMonsters(this.state.selectedMonsters,this.props.scenarioLevel);}},{key:'calculateSelectSize',value:function calculateSelectSize(){if(this.state.windowHeight>170){var selectSize=(this.state.windowHeight-170)/21;return selectSize;}else{return 4;}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:true,onRequestClose:function onRequestClose(){return _this2.props.onClose();},contentLabel:'Monsters',style:this.customStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Monsters--ListModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Monsters--ListModal--LevelContainer'},'Level: ',this.props.baseScenarioLevel,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'Monsters--ListModal--LevelSelect',disabled:this.props.hasBoss||this.props.monstersInPlay.length>0,value:this.props.levelAdjustment,onChange:function onChange(event){return _this2.props.setLevelAdjustment(parseInt(event.target.value,10));}},['-1','+0','+1','+2'].map(function(value,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i-1,value:i-1},value);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'Monsters--ListModal--Button',onClick:function onClick(){return _this2.props.onClose();}},'Close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Monsters--ListModal--MonsterSelectorContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.addMonsters(_this2.state.selectedMonsters,_this2.props.scenarioLevel);}},'Add Monster(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{size:this.calculateSelectSize(),onChange:function onChange(e){return _this2.handleMonsterSelection(e.target.options);},multiple:true,value:this.state.selectedMonsters,className:'Monsters--ListModal--Monsters',onDoubleClick:function onDoubleClick(){_this2.onMonsterSelectionDblClick();}},__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["e" /* MONSTER_LIST */].map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:name,key:name,disabled:_this2.props.monstersInPlay.includes(name)},name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Monsters--ListModal--BossSelectorContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:this.props.hasBoss,value:this.state.selectedBoss,onChange:function onChange(event){return _this2.selectBoss(event.target.value);}},__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["b" /* BOSS_LIST */].map(function(b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:b,key:b},b);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.props.hasBoss,onClick:function onClick(){return _this2.props.addBoss(_this2.state.selectedBoss,_this2.props.scenarioLevel,_this2.props.numPlayers);}},'Add Boss')),this.props.numPlayers===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Monsters--ListModal--Cover'},'Add Players First')));}}]);return ListModalComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var ListModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{levelAdjustment:state.players.levelAdjustment,monstersInPlay:Object.keys(state.monsters.monsters),allowIndividualMonsterLevels:state.monsters.allowIndividualMonsterLevels,hasBoss:state.boss!=null,baseScenarioLevel:__WEBPACK_IMPORTED_MODULE_6__store_players__["b" /* selectors */].baseScenarioLevel(state),scenarioLevel:__WEBPACK_IMPORTED_MODULE_6__store_players__["b" /* selectors */].scenarioLevel(state),numPlayers:__WEBPACK_IMPORTED_MODULE_6__store_players__["b" /* selectors */].numPlayers(state)};},function(dispatch,ownProps){return{setLevelAdjustment:function setLevelAdjustment(levelAdjustment){return Object(__WEBPACK_IMPORTED_MODULE_6__store_players__["e" /* setLevelAdjustmentAction */])(dispatch,levelAdjustment);},toggleAllowIndividualMonsterLevels:function toggleAllowIndividualMonsterLevels(){return Object(__WEBPACK_IMPORTED_MODULE_7__store_monsters__["g" /* toggleAllowIndividualMonsterLevels */])(dispatch);},addBoss:function addBoss(name,scenarioLevel,numPlayers){Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_boss__["d" /* setBossAction */])(dispatch,name,scenarioLevel,numPlayers);ownProps.onClose();},addMonsters:function addMonsters(monsterNames,scenarioLevel){Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_monsters__["d" /* addMonstersAction */])(dispatch,monsterNames,scenarioLevel);ownProps.onClose();},resetMonsters:function resetMonsters(monsterNames){Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_monsters__["f" /* resetMonstersAction */])(dispatch,monsterNames);}};})(ListModalComponent);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(171)(module)))

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heal.7e43977c.svg";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/retaliate.e0cc69e5.svg";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shield.859b3baa.svg";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pierce.904bbb03.svg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add_target.82b3eabf.svg";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/refresh_item.0b457b37.svg";

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerTrackers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlayerTracker__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddPlayer__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayerTrackers_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayerTrackers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PlayerTrackers_css__);
function PlayerTrackersComponentFunction(_ref){var playerNames=_ref.playerNames,hasMonstersInPlay=_ref.hasMonstersInPlay,selectableClasses=_ref.selectableClasses;var lastPlayerKey=0;if(playerNames.length>0)lastPlayerKey=parseInt(playerNames[playerNames.length-1].split(" ")[1],10);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"PlayerTrackers"},playerNames.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PlayerTracker__["a" /* PlayerTracker */],{key:p,name:p});}),!hasMonstersInPlay&&selectableClasses.length>0&&playerNames.length<5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AddPlayer__["a" /* AddPlayer */],{key:lastPlayerKey+1,initialPlayerNumber:lastPlayerKey+1}));}var PlayerTrackers=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{playerNames:Object.keys(state.players.players),hasMonstersInPlay:__WEBPACK_IMPORTED_MODULE_4__store_monsters__["c" /* selectors */].hasMonstersInPlay(state),selectableClasses:__WEBPACK_IMPORTED_MODULE_5__store_players__["b" /* selectors */].selectableClasses(state)};})(PlayerTrackersComponentFunction);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xp_svg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xp_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnitTracking_HPTracker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_players__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_players__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Brute_jpg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Brute_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Brute_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Cragheart_jpg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Cragheart_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Cragheart_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Mindthief_jpg__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Mindthief_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Mindthief_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Scoundrel_jpg__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Scoundrel_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Scoundrel_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Spellweaver_jpg__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Spellweaver_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Spellweaver_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tinkerer_jpg__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tinkerer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Tinkerer_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Sun_jpg__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Sun_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Sun_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Music_Note_jpg__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Music_Note_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Music_Note_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Triforce_jpg__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Triforce_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Triforce_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__angry_face_svg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__angry_face_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__angry_face_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__eclipse_svg__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__eclipse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__eclipse_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__saw_svg__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__saw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__saw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__two_minis_svg__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__two_minis_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__two_minis_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PlayerTracker_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PlayerTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__PlayerTracker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import xpIcon from "./xp_white.svg";
// import { PerksModal } from './PerksModal';
// import { SummonModal } from './SummonModal';
// import { SummonTrackers } from '../Summons/SummonTrackers';
// import { BonusSelectors } from '../UnitTracking/BonusSelectors';
// import { StatusEffectTracker } from '../UnitTracking/StatusEffectTracker';
var CLASS_ICON_MAPPING={Brute:__WEBPACK_IMPORTED_MODULE_8__Brute_jpg___default.a,Cragheart:__WEBPACK_IMPORTED_MODULE_9__Cragheart_jpg___default.a,Mindthief:__WEBPACK_IMPORTED_MODULE_10__Mindthief_jpg___default.a,Scoundrel:__WEBPACK_IMPORTED_MODULE_11__Scoundrel_jpg___default.a,Spellweaver:__WEBPACK_IMPORTED_MODULE_12__Spellweaver_jpg___default.a,Tinkerer:__WEBPACK_IMPORTED_MODULE_13__Tinkerer_jpg___default.a,Sun:__WEBPACK_IMPORTED_MODULE_14__Sun_jpg___default.a,'Music Note':__WEBPACK_IMPORTED_MODULE_15__Music_Note_jpg___default.a,Triforce:__WEBPACK_IMPORTED_MODULE_16__Triforce_jpg___default.a,'Angry Face':__WEBPACK_IMPORTED_MODULE_17__angry_face_svg___default.a,'Moon/Eclipse':__WEBPACK_IMPORTED_MODULE_18__eclipse_svg___default.a,Saw:__WEBPACK_IMPORTED_MODULE_19__saw_svg___default.a,'Two-Minis':__WEBPACK_IMPORTED_MODULE_20__two_minis_svg___default.a};var PlayerTrackerComponent=function(_React$Component){_inherits(PlayerTrackerComponent,_React$Component);function PlayerTrackerComponent(props){_classCallCheck(this,PlayerTrackerComponent);var _this=_possibleConstructorReturn(this,(PlayerTrackerComponent.__proto__||Object.getPrototypeOf(PlayerTrackerComponent)).call(this,props));_this.state={xp:_this.props.player.xp,level:_this.props.player.level};return _this;}_createClass(PlayerTrackerComponent,[{key:'setXP',value:function setXP(xp){if(xp<0){return;}this.setState({xp:xp});this.props.setXP(xp);this.setLevel(Object(__WEBPACK_IMPORTED_MODULE_7__lib_players__["a" /* getLevel */])(xp));}},{key:'setLevel',value:function setLevel(level){this.setState({level:level});this.props.selectLevel(parseInt(level,10));this.setState({xp:Object(__WEBPACK_IMPORTED_MODULE_7__lib_players__["b" /* getXP */])(level)});}},{key:'togglePerksModal',value:function togglePerksModal(showPerksModal){this.setState({showPerksModal:showPerksModal});}},{key:'toggleSummonModal',value:function toggleSummonModal(showSummonModal){this.setState({showSummonModal:showSummonModal});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--Container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'PlayerTracker--Name'},this.props.name,!this.props.hasMonstersInPlay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.removePlayer();}},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--Class'},this.props.player.class,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'PlayerTracker--Class--Icon',src:CLASS_ICON_MAPPING[this.props.player.class],alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--Description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--Stats'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--XP'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'PlayerTracker--XP--Icon',src:__WEBPACK_IMPORTED_MODULE_2__xp_svg___default.a,alt:'xp'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--XP--Buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.xp===0,onClick:function onClick(){return _this2.setXP(_this2.state.xp-1);}},'-'),this.state.xp,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(event){if(event.shiftKey){_this2.setXP(_this2.state.xp+10);}else{_this2.setXP(_this2.state.xp+1);}}},'+'),'L:',this.state.level))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--LevelSelector'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Level:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:this.props.hasMonstersInPlay,value:this.state.level,onChange:function onChange(event){return _this2.setLevel(parseInt(event.target.value,10));}},new Array(9).fill().map(function(_,i){var level=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:level,value:level},level);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UnitTracking_HPTracker__["a" /* HPTracker */],{key:this.props.player.maxHP,currentHP:this.props.player.hp,maxHP:this.props.player.maxHP,onHPChange:function onHPChange(hp){return _this2.props.player.hp!==hp&&_this2.props.setHP(hp);}})));}}]);return PlayerTrackerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var PlayerTracker=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{player:state.players.players[ownProps.name],hasMonstersInPlay:__WEBPACK_IMPORTED_MODULE_6__store_monsters__["c" /* selectors */].hasMonstersInPlay(state),xp:state.players.players[ownProps.name].xp,level:state.players.players[ownProps.name].level};},function(dispatch,ownProps){return{setXP:function setXP(xp){return Object(__WEBPACK_IMPORTED_MODULE_4__store_players__["f" /* setXPAction */])(dispatch,ownProps.name,xp);},selectLevel:function selectLevel(level){return Object(__WEBPACK_IMPORTED_MODULE_4__store_players__["d" /* setLevelAction */])(dispatch,ownProps.name,level);},removePlayer:function removePlayer(){return Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_players__["d" /* removePlayerAction */])(dispatch,ownProps.name);},toggleStatusEffect:function toggleStatusEffect(statusEffect){return Object(__WEBPACK_IMPORTED_MODULE_4__store_players__["g" /* toggleStatusEffectAction */])(dispatch,ownProps.name,statusEffect);},setHP:function setHP(hp){return Object(__WEBPACK_IMPORTED_MODULE_4__store_players__["c" /* setHPAction */])(dispatch,ownProps.name,hp);}};})(PlayerTrackerComponent);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xp.518b8fcd.svg";

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLevel;
/* harmony export (immutable) */ __webpack_exports__["b"] = getXP;
function getXPtable(){var table=[45];for(var i=1;i<9;i++){table.push(table[i-1]+45+i*5);}return table;}var XPtable=getXPtable();function getLevel(xp){for(var i=9;i>0;i--){if(XPtable[i-1]<=xp)return i+1;}return 1;}function getXP(level){if(level===1)return 0;else return XPtable[level-2];}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wgARCABLAEsDASIAAhEBAxEB/8QAHAAAAgMAAwEAAAAAAAAAAAAAAAcEBQYBAgMI/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAWoHBzXy0qVN7k7M+gOaunNYdex1Iy1JK3fKxMoy1w8zE4yP4L9Dzky5US2VY64WzcKL0aM32o6swsN+qFaDd0jsTsj3tTCEcK+Z4q6QC8dCzbZDmgABFwLIhHzxe0jsNB7AAB//xAAiEAACAgEEAgMBAAAAAAAAAAADBAIFAQAGEBQRIBIhIkH/2gAIAQEAAQUC5cYgqB5ojjFBZdQ+M+faUsQjd2OX2P5Wrdp548VE6Ky7oOPOvOt0vTxLjaS343W58ipMzUZVYgyvpg0AChuOfcnBWzVtaUqeoQyQn4rKwxJFLrb1h1WPOr6xm2fSDpkiVtiF8eKpbDtsl3lWliql4VuW4L7nruaAEjWW6HMgXqr/AMabWA+C0rDITp66T5xBgIc4YnG5Qyg3rbinWRuWu3YarbM6Eh5w0quCC4+LVKLqtahM1neM9Su427WdgnrgA8G3cMucap0MvsiHEUPZmMSL5x97ehGNX6f/xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAEDAQE/AU//xAAUEQEAAAAAAAAAAAAAAAAAAABA/9oACAECAQE/AU//xAAvEAACAQIDBgQGAwEAAAAAAAABAgMAIRARMRITIkFRYQQgMnEUIzNCodEkUnLB/9oACAEBAAY/AsWlkNhTTS89B0rdyH5L69j5yzWAvWSHKBPT374RRcs8z7U8hsFGQorLaZNe46+X4RM1XVj1xfxDc7Cl8KpsvE36pJY9RypJYrq2DSSnJVpmkT+ObbPSuUiHTqK2485IevMe9KiepjlXaNfzTyNcsc8N1Ifkyfg4bsZrCp0OudXrahPuDpXDZ/uQ0viUXZYcuVbsPsHlRjnQhh+cP+1Gu5MmQ9XWvi4R/v8AeMZUldm5IpI422Xc0sXjtOUnT3rKQBl5MKvxRcnq9oV9RpURQFFhRVhmDrRA+i11OG9ezyXPYVI/2jhWr1wHaj/qaBlj2Q63VqCRJsqMWjPq+096Hh5Rluzx0+VmPCuPxMw+Uug6nzGULk7anrUTj6I1wC6RL6qVEGSrYDzyq4zXI2wgKgAsMz38v//EACYQAAIBBAEEAQUBAAAAAAAAAAABESExQVFhEHGBkSChwdHh8fD/2gAIAQEAAT8h6w/FU54GsaIw0MvMhvqCElW+LHwwJN2Q0PNQm/QdrYTvfwIilKyegLopDosJK3F9mMPjJmdkKatXtCaVVHLDMnLXZaHJQp7cdFFVpb2K1jQS6bEKYupf4Q2fG39QryUl85KWElb7DE5d+Xs8xyORWkfeIbGNcGsNyRm+Mso+p84O8qf6W0aWo3PcDnvJc6PuigcRa5p5Raz9m8IKItBSKmbRUMHcXxO0B86RlaR4AAS+Jbi5QzNJba+j5F6Dq9vHcRHmCBXpOEeStF+lDFoTBregit43hZ8j/ouAXWt6GKJaqhMReatrqhpZ6g1ykiNYQt94MCLRFThe2RlW115uwvg0LfJQoI3mjwfJiVaw2E1bkNKQBL5JAurOwqdNjcImrKfj/9oADAMBAAIAAwAAABDzjEDzQ30THCXAgHgUGlSyhkzz/8QAGREBAQEBAQEAAAAAAAAAAAAAAQARECAh/9oACAEDAQE/EOZ4JbJ42WzDMeX53//EABQRAQAAAAAAAAAAAAAAAAAAAED/2gAIAQIBAT8QT//EACQQAQACAgICAQUBAQAAAAAAAAEAESExQVFhcaEQIIGRscHR/9oACAEBAAE/EPqRtKl5XAObZmZr9JDx3A9g9KjUCAUtAj2QfJ9htOuWEJcWoCNQA10bXTxUxRTFtdyjapnimX5mtcy6UwfmBww99B57mIbenv6MLqg2vPkliRUZzyQ4JaKHUsDSbZ4PqWLFNLfcXMxjY5EfeJb+pKwuBeTcpQtU+/zuHt1ZyufYcS5ZrQtdA8yzhYDfw3l7I0G/0xO+0eYVIcg2fh/iV1FYdqt1DQwi2zL8x/b5eT+KhQloXbzvr1Hfck44vSCAgRyNytTa2Ku+B8Q2RQtmM8YgN78vD5joQUWKPP8AolrvqpSv4SwxG5+uQj6FocBEOWx0Uyn/ACUoK5QNUwegza1OZcqqATfS88QrS/CtsFzsu75mSnOUvE9Sx7K1JtqMkNkGYWgHHuZ+zOFeEP5FOvckB8Pwhm1i8C69qDQPR4CI3AVYHcEZYr47b4mAvi4jHGnJ6/DcXKbmYcNeoo24qirP77lBbO9C99V0EMPAoQMX5jZwIe3Pn6bh4gFnVj8TuR4QafaWeIB7mIzh+JTQLJee+YVah8BGSBpii/hsZiUZDn7AdwHUCsg1cy2JRm3nwl3ay57HzBnyPOL17YJAXQBKCruV9t4bAbMWPmFMALY/MIiGmQYL3j7f/9k="

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wgARCABLAEsDASIAAhEBAxEB/8QAHAAAAQQDAQAAAAAAAAAAAAAAAAEFBgcCAwQI/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAG0GFiq0lrcwIrx2xsLQnXnR1S/iIyxPPPKDQAAAACTaFKmK7dSgAAgok8SCE3eCv8AgvGqxiNj0unbeG9KRuLsDDMDFMwrvud3o2KigAAB/8QAJBAAAgIBAwQCAwAAAAAAAAAAAwQCBQEABhEQEiAwExUUFjL/2gAIAQEAAQUC1aWYURm3A3PX3D+o2TsZYu3sZrNwYJMBhnj0vrbK2ZSlPPjXukSPW3YW586aL87HoDuJoYvTzn1lHMRPJSg/IT/XGu6O2B8PxJF3qrXMNr/Uv9q1K4YgQxCHpaVYn4t1TS0pQlHVIvFqxCKAR+XGt29uF9u12VRY9BBxJaY/rHl//8QAFBEBAAAAAAAAAAAAAAAAAAAAQP/aAAgBAwEBPwFP/8QAFBEBAAAAAAAAAAAAAAAAAAAAQP/aAAgBAgEBPwFP/8QALRAAAgADBQYFBQAAAAAAAAAAAQIAAxESEyEiQQQQIDAxcRQyUVJhIzM0kaH/2gAIAQEABj8CjHNM0QRkAlj4j8g/qLQ2hq9oxm1i72sBPRxFqS6uvqN/h9nP1T5m9sVdiT87sOAPKOXVYu2F1MPSusdImTffyMTCpcB7IpaOvK68srMFlh1HF8Qk4TjVxWkeZKd4x2l69omLtFb3WvAZslbSjCkV8Oe1YCvLuk1YwktPKuA31OSaOjiKNLtLoUjOKd4RJgtJTMICSlCqNByJSKotlovZ33X/AJyVExQwCVFYPH//xAAlEAEAAgICAQMEAwAAAAAAAAABABEhMUFRIDBhcRCBkdGhwfH/2gAIAQEAAT8hVHX4mRbv9EfTgm8Du6H2S0xAoh9ss7K6D8zhhCnMvPc3zHONfrRyzuVWsZ9x9PiJY3tjZjThT9w9wEWIx7R1Lyu3nz/P2nBg5Oxj/UFjPumbe/R6FOB4fS5UqNnh1v8AqH8TRfDmU1qimKhtcKKH3qoTBDbwPLRsq4NigYZ3LkWQgkOjqHOKhghZ6Fb/AMMfJLtD8xOlftzDNqlOZogt5CNYajteptVkQzH1dODrNPQqwCBpmtwa83//2gAMAwEAAgADAAAAENJHLWYAQAYaARCRRSLTDKCdPPP/xAAZEQADAQEBAAAAAAAAAAAAAAAAAREQIDD/2gAIAQMBAT8QWzFxBbSlKXw//8QAFBEBAAAAAAAAAAAAAAAAAAAAQP/aAAgBAgEBPxBP/8QAIxABAAICAgICAgMAAAAAAAAAAQARIUExUWFxIIGRsRAwwf/aAAgBAQABPxC0NLStn3HVVoRbf6kZVG6cfGYEV6DFL0Q81qH1DSSOF8bRvxikicirpEPAG0gUseYVstrkGq9puWjFfkx1BlRRemsRA4dltx45fRBo4D5hCy5OnxUp6K23vY/aZP0SsHOdMWq4Nm4rSqfIwq/nYZcPy+ol0huy60nG5d7yTCVanmZJinPVePmKZMMAFoKe8wAoJouVTno7/qQcSsP6PhvCm2osopVNcMXScit+J0Be57SoczYNO/c0e+DV+MykL7lLjXfv+faHuPPztBsvmcItNFscylwgNleYXrVjIO+4FUgOL7hoOphhNGZ+iLf6wIv9R+vNXUPBOOrSVOIQwqNQfLDgru6grRbKRyP1BXkhYPvcCpWK9fH3BQDj56mb4GBZyeYvGQHUVjffy//Z"

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Sun.b086e905.jpg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Music Note.4587d470.jpg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Triforce.e4e33415.jpg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/angry-face.b948d219.svg";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eclipse.6a4b331c.svg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/saw.29fb23b7.svg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/two-minis.fa0833bb.svg";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_players__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddPlayer_css__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddPlayer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddPlayer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddPlayerComponent=function(_React$Component){_inherits(AddPlayerComponent,_React$Component);function AddPlayerComponent(props){_classCallCheck(this,AddPlayerComponent);var _this=_possibleConstructorReturn(this,(AddPlayerComponent.__proto__||Object.getPrototypeOf(AddPlayerComponent)).call(this,props));var initialPlayerName='Player '+props.initialPlayerNumber;_this.state={selectedClass:props.selectableClasses[0],level:1,playerNameInput:initialPlayerName,duplicateNameWarning:props.playerNames.includes(initialPlayerName),numberOfPlayers:0};return _this;}_createClass(AddPlayerComponent,[{key:'playerNameInputChange',value:function playerNameInputChange(input){this.setState({playerNameInput:input,duplicateNameWarning:this.props.playerNames.includes(input)});}},{key:'selectClass',value:function selectClass(selectedClass){this.setState({selectedClass:selectedClass});}},{key:'selectLevel',value:function selectLevel(level){this.setState({level:level});}},{key:'addPlayer',value:function addPlayer(name,characterClass,level){if(this.state.duplicateNameWarning){return;}this.props.addPlayer(name,characterClass,level);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddPlayer--container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'AddPlayer--playerName',placeholder:'Name'// || this.props.playerNames.length === 4}
,value:this.state.playerNameInput,onChange:function onChange(e){return _this2.playerNameInputChange(e.target.value);},onKeyPress:function onKeyPress(e){if(e.key==='Enter'){_this2.addPlayer(_this2.state.playerNameInput,_this2.state.selectedClass,_this2.state.level);}}}),this.state.duplicateNameWarning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddPlayer--duplicateNameWarning'},'A player with that name already exists'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__('AddPlayer--section','AddPlayer--selectors')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddPlayer--selector'},'Class:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{size:'5',value:this.state.selectedClass,onChange:function onChange(event){return _this2.selectClass(event.target.value);}},this.props.selectableClasses.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:c,key:c},c);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddPlayer--selector'},'Level:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{size:'5',value:this.state.level,onChange:function onChange(event){return _this2.selectLevel(event.target.value);}},new Array(9).fill().map(function(_,i){var level=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:level,value:level},level);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__('AddPlayer--section','AddPlayer--button',this.state.duplicateNameWarning&&'AddPlayer--button--disabled'),disabled:this.state.duplicateNameWarning,onClick:function onClick(){return _this2.addPlayer(_this2.state.playerNameInput,_this2.state.selectedClass,_this2.state.level);}},'Add Player'));}}]);return AddPlayerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var AddPlayer=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{players:state.players.players,playerNames:Object.keys(state.players.players),selectableClasses:__WEBPACK_IMPORTED_MODULE_4__store_players__["b" /* selectors */].selectableClasses(state)};},function(dispatch,ownProps){return{addPlayer:function addPlayer(name,characterClass,level){return Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_players__["c" /* addPlayerAction */])(dispatch,name,characterClass,parseInt(level,10));}};})(AddPlayerComponent);

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonsterDecks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Deck__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FutureModal__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterDecks_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterDecks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MonsterDecks_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as classNames from 'classnames';
var peekingCards;var peekingDeckName;var MonsterDecksComponent=function(_React$Component){_inherits(MonsterDecksComponent,_React$Component);function MonsterDecksComponent(props){_classCallCheck(this,MonsterDecksComponent);var _this=_possibleConstructorReturn(this,(MonsterDecksComponent.__proto__||Object.getPrototypeOf(MonsterDecksComponent)).call(this,props));_this.peekFuture=function(name,number,mode){peekingDeckName=name;var deck=_this.props.decks[name];console.log(deck.cards,deck.currentIndex);var cards=deck.cards;var startIndex=deck.currentIndex+1;var endIndex=startIndex+number;if(endIndex<=cards.length){peekingCards=cards.slice(startIndex,endIndex);console.log("Ok",peekingCards);}else{endIndex=endIndex-cards.length;peekingCards=cards.slice(startIndex,cards.length).concat(cards.slice(0,endIndex));console.log("Nok",peekingCards);}_this.setState({mode:mode});_this.toggleFutureModal(!_this.state.showFutureModal);};_this.onSubmitAction=function(seqs,mode){var deck=_this.props.decks[peekingDeckName];console.log("onSubmitAction",seqs,deck,mode);var cards=deck.cards;var startIndex=deck.currentIndex+1;var offset=0;var seq_length=Object.keys(seqs).length;if(startIndex+seq_length>cards.length)offset=startIndex+seq_length-cards.length;console.log("offset",offset);var new_cards=cards.slice(0+offset,startIndex);// for (let i = 0; i < seq_length; i++) {
//     console.log(i, startIndex, seqs[i], offset);
//     console.log(cards[startIndex + seqs[i] - 1], peekingCards[i]);
//     // cards[startIndex + seqs[i]] = peekingCards[i];
// }
for(var i=0;i<seq_length;i++){new_cards.push({});}var put_bottom=false;for(var _i=0;_i<seq_length;_i++){if(seqs[_i]===-1){seqs[_i]=seq_length;put_bottom=true;}new_cards[startIndex-offset+seqs[_i]-1]=peekingCards[_i];}if(offset===0)new_cards=new_cards.concat(cards.slice(startIndex+seq_length,cards.length+1));if(put_bottom){var temp=new_cards[startIndex-offset+seq_length-1];new_cards[startIndex-offset+seq_length-1]=new_cards[cards.length-1];new_cards[cards.length-1]=temp;}console.log("onSubmitAction",cards,new_cards);_this.props.decks[peekingDeckName].cards=new_cards;_this.props.decks[peekingDeckName].currentIndex-=offset;};_this.state={showFutureModal:false,mode:0};return _this;}_createClass(MonsterDecksComponent,[{key:'toggleFutureModal',value:function toggleFutureModal(showFutureModal){this.setState({showFutureModal:showFutureModal});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,decks=_props.decks,showStats=_props.showStats,numPlayers=_props.numPlayers,scenarioLevel=_props.scenarioLevel,boss=_props.boss;var deckNames=Object.keys(decks);var activeDecks=deckNames.filter(function(m){return decks[m].active;});var inactiveDecks=deckNames.filter(function(m){return!decks[m].active;});var deckOrder=activeDecks.sort(function(a,b){var deckA=decks[a];var deckB=decks[b];if(!deckA.currentCard&&!deckB.currentCard){return 0;}return deckA.currentCard.initiative-deckB.currentCard.initiative;}).concat(inactiveDecks);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.showFutureModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FutureModal__["a" /* FutureModal */],{onClose:function onClose(){return _this2.toggleFutureModal(false);},submitAction:function submitAction(seqs){return _this2.onSubmitAction(seqs);},peekingDeckName:peekingDeckName,peekingCards:peekingCards,mode:this.state.mode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterDecks'},deckOrder.map(function(name){var deck=decks[name];if(!showStats){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Deck__["a" /* Deck */],{key:name,name:name,card:deck.currentCard,active:deck.active,peekFutureFunc:_this2.peekFuture});}var monsterStats=void 0;if(name==='Boss'){monsterStats=__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["c" /* BOSS_STATS */][boss[0].name][scenarioLevel](numPlayers);}else{monsterStats=__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["d" /* MONSTERS */][name].stats[scenarioLevel];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Deck__["a" /* Deck */],{key:name,name:name,card:deck.currentCard,active:deck.active,stats:monsterStats,peekFutureFunc:_this2.peekFuture});})));}}]);return MonsterDecksComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var MonsterDecks=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{decks:state.monsterDecks,numPlayers:__WEBPACK_IMPORTED_MODULE_4__store_players__["b" /* selectors */].numPlayers(state),scenarioLevel:__WEBPACK_IMPORTED_MODULE_4__store_players__["b" /* selectors */].scenarioLevel(state),boss:state.boss};})(MonsterDecksComponent);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Deck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MonsterTracker_MonsterStats__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__monster_card_back_jpg__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__monster_card_back_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__monster_card_back_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aesther_diviner_mix_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aesther_diviner_mix_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__aesther_diviner_mix_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Deck_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Deck_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Deck_css__);
function Stats(_ref){var name=_ref.name,stats=_ref.stats;if(name==="Boss"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--Stats"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MonsterTracker_MonsterStats__["a" /* MonsterStats */],{className:"MonsterTracker--Boss--Stats",stats:stats}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--Stats"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MonsterTracker_MonsterStats__["a" /* MonsterStats */],{stats:stats.normal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MonsterTracker_MonsterStats__["a" /* MonsterStats */],{stats:stats.elite,elite:true}));}function Deck(_ref2){var name=_ref2.name,level=_ref2.level,card=_ref2.card,active=_ref2.active,stats=_ref2.stats,peekFutureFunc=_ref2.peekFutureFunc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--Container"},stats&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stats,{name:name,stats:stats}),!card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--CardBack"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__monster_card_back_jpg___default.a,className:"Monsters--Deck--CardBackImage",alt:"card back"}),name!=="Boss"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg___default.a,className:"Monster--Card--PeekFutureMini",onClick:function onClick(){return peekFutureFunc(name,1,1);}}),name!=="Boss"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg___default.a,className:"Monster--Card--PeekFutureSmall",onClick:function onClick(){return peekFutureFunc(name,2,1);}}),name!=="Boss"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__aesther_diviner_mix_svg___default.a,className:"Monster--Card--PeekFutureMix",onClick:function onClick(){return peekFutureFunc(name,2,-1);}}),name!=="Boss"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__aesther_diviner_white_svg___default.a,className:"Monster--Card--PeekFutureBig",onClick:function onClick(){return peekFutureFunc(name,4,1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--CardBackName"},name),!active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters--Deck--InactiveCover"},"Inactive")),card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* Card */],{name:name,card:card,stats:stats}));}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MOVEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RANGE; });
/* unused harmony export HEALTH */
/* unused harmony export STATS */
/* harmony export (immutable) */ __webpack_exports__["d"] = iconForStat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attack_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movement_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movement_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movement_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__range_svg__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__range_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__range_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__health_svg__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__health_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__health_svg__);
var _statIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ATTACK="attack";var MOVEMENT="movement";var RANGE="range";var HEALTH="health";var statIcons=(_statIcons={},_defineProperty(_statIcons,ATTACK,__WEBPACK_IMPORTED_MODULE_0__attack_svg___default.a),_defineProperty(_statIcons,MOVEMENT,__WEBPACK_IMPORTED_MODULE_1__movement_svg___default.a),_defineProperty(_statIcons,RANGE,__WEBPACK_IMPORTED_MODULE_2__range_svg___default.a),_defineProperty(_statIcons,HEALTH,__WEBPACK_IMPORTED_MODULE_3__health_svg___default.a),_statIcons);var STATS=Object.keys(statIcons);function iconForStat(name){return statIcons[name];}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attack.79852f29.svg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/movement.bea37385.svg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/range.786732e0.svg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/health.7e43977c.svg";

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/monster_card_back.1c2fbc78.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aesther-diviner-white.0c9c0a2b.svg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aesther-diviner-mix.d71f611c.svg";

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FutureModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FutureModal_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FutureModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FutureModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sees2_wav__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sees2_wav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sees2_wav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__knows2_wav__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__knows2_wav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__knows2_wav__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FutureModalComponent=function(_React$Component){_inherits(FutureModalComponent,_React$Component);function FutureModalComponent(props){_classCallCheck(this,FutureModalComponent);var _this=_possibleConstructorReturn(this,(FutureModalComponent.__proto__||Object.getPrototypeOf(FutureModalComponent)).call(this,props));_this._updateDimensions=function(){_this.setState({windowHeight:document.documentElement.clientHeight});};_this.customStyles={content:{top:"90px",left:"150px",right:"150px",bottom:"200px",padding:"10px 20px",overflowY:"hidden"// width: "1400px"
}};var seqs={};for(var i=0;i<props.peekingCards.length;i++){seqs[i]=i+1;}var audio=null;_this.state={windowHeight:document.documentElement.clientHeight,seq:seqs,textChoice:Math.random()>=0.5};return _this;}_createClass(FutureModalComponent,[{key:'setSEQ',value:function setSEQ(seq,i){if(this.props.mode!==-1&&seq<1||seq>this.props.peekingCards.length){return;}var seqs=this.state.seq;seqs[i]=seq;this.setState({seq:seqs});}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener("resize",this._updateDimensions);this.audio=new Audio(this.state.textChoice?__WEBPACK_IMPORTED_MODULE_5__sees2_wav___default.a:__WEBPACK_IMPORTED_MODULE_6__knows2_wav___default.a);console.log(this.audio,this.props.mode);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("resize",this._updateDimensions);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,{isOpen:true,onRequestClose:function onRequestClose(){return _this2.props.onClose();},contentLabel:'Future',style:this.customStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Future--ListModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Deck--PlayedCards'},this.props.peekingCards.map(function(card,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'Future--ListModal--MonsterSelectorContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Card__["a" /* Card */],{key:i,name:_this2.props.peekingDeckName,card:card}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--SEQ--Buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'PlayerTracker--SEQ--Button',disabled:_this2.state.seq[i]===_this2.props.mode,onClick:function onClick(){return _this2.setSEQ(_this2.state.seq[i]-1,i);}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlayerTracker--SEQ'},_this2.state.seq[i]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'PlayerTracker--SEQ--Button',disabled:_this2.state.seq[i]===_this2.props.peekingCards.length,onClick:function onClick(event){_this2.setSEQ(_this2.state.seq[i]+1,i);}},'+')));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'Future--ListModal--Button',onClick:function onClick(){_this2.audio.play();var that=_this2;setTimeout(function(){that.props.submitAction(that.state.seq,that.props.mode);that.props.onClose();},_this2.state.textChoice?4000:3000);}},this.state.textChoice?"观今夜天象，知天下大事!":"知天易，逆天难!")));}}]);return FutureModalComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var FutureModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};},function(dispatch,ownProps){return{};})(FutureModalComponent);

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sees2.d12fcb3f.wav";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/knows2.633dec68.wav";

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MonsterTrackersComponentFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonsterTrackers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MonsterTracker__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonsterTrackers_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonsterTrackers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MonsterTrackers_css__);
function MonsterTrackersComponentFunction(_ref){var boss=_ref.boss,monsterNames=_ref.monsterNames;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Monsters"},boss&&boss[0]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MonsterTracker__["a" /* BossMonsterTracker */],{key:boss[0].name,boss:boss[0],index:0}),boss&&boss[1]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MonsterTracker__["a" /* BossMonsterTracker */],{boss:boss[1],index:1}),monsterNames.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MonsterTracker__["b" /* MonsterTracker */],{key:name,name:name});}));}var MonsterTrackers=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{boss:state.boss,monsterNames:Object.keys(state.monsters.monsters)};})(MonsterTrackersComponentFunction);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MonsterTracker__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__MonsterTracker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BossMonsterTracker__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BossMonsterTracker__["a"]; });


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonsterTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Monster__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MonsterStats__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnitTracking_StatusEffectTracker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions_monsters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_monsterDecks__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__damage_1_png__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__damage_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__damage_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__damage_5_png__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__damage_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__damage_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__heal_png__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__heal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__heal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MonsterTracker_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MonsterTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__MonsterTracker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonsterTrackerComponent=function(_React$Component){_inherits(MonsterTrackerComponent,_React$Component);function MonsterTrackerComponent(){_classCallCheck(this,MonsterTrackerComponent);return _possibleConstructorReturn(this,(MonsterTrackerComponent.__proto__||Object.getPrototypeOf(MonsterTrackerComponent)).apply(this,arguments));}_createClass(MonsterTrackerComponent,[{key:'onToggleAlive',value:function onToggleAlive(index){var activeChange=this.props.monsters.filter(function(_,i){return i!==index;}).every(function(m){return!m.alive;});if(activeChange){this.props.toggleActive(this.props.name);}this.props.toggleAlive(index);}},{key:'onDealDamage',value:function onDealDamage(index,damage){if(this.props.monsters[index].currentHP-damage<=0){var activeChange=this.props.monsters.filter(function(_,i){return i!==index;}).every(function(m){return!m.alive;});if(activeChange){this.props.toggleActive(this.props.name);}}this.props.dealDamage(index,damage);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,name=_props.name,monsters=_props.monsters,scenarioLevel=_props.scenarioLevel,removeMonster=_props.removeMonster,allStatusEffects=_props.allStatusEffects,toggleElite=_props.toggleElite,toggleAllStatusEffects=_props.toggleAllStatusEffects,dealDamage=_props.dealDamage;var monsterStats=__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["d" /* MONSTERS */][name].stats[scenarioLevel];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--Container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'MonsterTracker--Name'},name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return removeMonster();}},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--StatsContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MonsterStats__["a" /* MonsterStats */],{stats:monsterStats.normal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MonsterStats__["a" /* MonsterStats */],{stats:monsterStats.elite,elite:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--Controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--StatusEffects--ToggleAll'},'Toggle All:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnitTracking_StatusEffectTracker__["a" /* StatusEffectTracker */],{statusEffects:allStatusEffects,onToggle:function onToggle(s){return toggleAllStatusEffects(s);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--MonsterSelectors'},monsters.map(function(_ref,i){var alive=_ref.alive,elite=_ref.elite;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:i,disabled:alive,className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'MonsterTracker--MonsterSelector':true,'MonsterTracker--MonsterSelector--Alive':!alive,'MonsterTracker--MonsterSelector--Narrow':i+1>=10}),onClick:function onClick(){return _this2.onToggleAlive(i);}},i+1);}))),monsters.map(function(_ref2,i){var alive=_ref2.alive,elite=_ref2.elite,level=_ref2.level;var individualMonsterStats=level!==scenarioLevel&&__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["d" /* MONSTERS */][name].stats[level];return alive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:i},individualMonsterStats&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--StatsContainer'},elite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MonsterStats__["a" /* MonsterStats */],{stats:individualMonsterStats.elite,elite:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MonsterStats__["a" /* MonsterStats */],{stats:individualMonsterStats.normal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames__({'MonsterTracker--Monster':true,'MonsterTracker--Monster--Elite':elite})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MonsterTracker--Monster--Controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'MonsterTracker--Monster--Number'},''+(i+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.onToggleAlive(i);}},'Kill'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return toggleElite(i);}},'Normal/Elite')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'MonsterTracker--Heal--Icon',src:__WEBPACK_IMPORTED_MODULE_13__heal_png___default.a,alt:'heal',onClick:function onClick(){return _this2.onDealDamage(i,-1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'MonsterTracker--Damage--Icon damage-1',src:__WEBPACK_IMPORTED_MODULE_11__damage_1_png___default.a,alt:'damage-1',onClick:function onClick(){return _this2.onDealDamage(i,1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'MonsterTracker--Damage--Icon damage-5',src:__WEBPACK_IMPORTED_MODULE_12__damage_5_png___default.a,alt:'damage-5',onClick:function onClick(){return _this2.onDealDamage(i,5);}})),alive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Monster__["a" /* Monster */],{name:name,index:i})));})));}}]);return MonsterTrackerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var MonsterTracker=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{monsters:state.monsters.monsters[ownProps.name].monsters,allowIndividualMonsterLevels:state.monsters.allowIndividualMonsterLevels,// global status effects across all monsters
allStatusEffects:__WEBPACK_IMPORTED_MODULE_7__store_monsters__["c" /* selectors */].allStatusEffects(state,ownProps.name),scenarioLevel:__WEBPACK_IMPORTED_MODULE_8__store_players__["b" /* selectors */].scenarioLevel(state)};},function(dispatch,ownProps){return{removeMonster:function removeMonster(){Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_monsters__["e" /* removeMonsterAction */])(dispatch,ownProps.name);},toggleAlive:function toggleAlive(i){return Object(__WEBPACK_IMPORTED_MODULE_7__store_monsters__["e" /* toggleAliveAction */])(dispatch,ownProps.name,i);},toggleElite:function toggleElite(i){return Object(__WEBPACK_IMPORTED_MODULE_7__store_monsters__["h" /* toggleEliteAction */])(dispatch,ownProps.name,i);},toggleActive:function toggleActive(active){Object(__WEBPACK_IMPORTED_MODULE_10__store_monsterDecks__["d" /* toggleActiveAction */])(dispatch,ownProps.name,active);},toggleAllStatusEffects:function toggleAllStatusEffects(statusEffect){return Object(__WEBPACK_IMPORTED_MODULE_7__store_monsters__["f" /* toggleAllStatusEffectsAction */])(dispatch,ownProps.name,statusEffect);},dealDamage:function dealDamage(i,damage){return Object(__WEBPACK_IMPORTED_MODULE_7__store_monsters__["a" /* dealDamageAction */])(dispatch,ownProps.name,i,damage);}};})(MonsterTrackerComponent);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Monster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnitTracking_StatusEffectTracker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnitTracking_HPTrackerFunction__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Monster_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Monster_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Monster_css__);
// import { HPTracker } from '../../UnitTracking/HPTracker';
function MonsterComponent(_ref){var maxHP=_ref.maxHP,elite=_ref.elite,_ref$immunities=_ref.immunities,immunities=_ref$immunities===undefined?[]:_ref$immunities,statusEffects=_ref.statusEffects,toggleStatusEffect=_ref.toggleStatusEffect,setHP=_ref.setHP,name=_ref.name,index=_ref.index,monsterData=_ref.monsterData;//return (<div className={classNames({"Monster--Container": true, "Monster--Container--Elite": elite})}>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UnitTracking_StatusEffectTracker__["a" /* StatusEffectTracker */],{statusEffects:statusEffects,onToggle:function onToggle(s){return toggleStatusEffect(s);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UnitTracking_HPTrackerFunction__["a" /* HPTrackerFunction */],{monsterData:monsterData}));}var Monster=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){if(ownProps.name==='Boss'){return{};}var monster=state.monsters.monsters[ownProps.name].monsters[ownProps.index];return Object.assign({},monster,{monsterData:monster});},function(dispatch,ownProps){return{toggleStatusEffect:function toggleStatusEffect(s){return Object(__WEBPACK_IMPORTED_MODULE_3__store_monsters__["i" /* toggleStatusEffectAction */])(dispatch,ownProps.name,ownProps.index,s);},setHP:function setHP(hp){return Object(__WEBPACK_IMPORTED_MODULE_3__store_monsters__["d" /* setHPAction */])(dispatch,ownProps.name,ownProps.index,hp);}};})(MonsterComponent);

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BossMonsterTrackerComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BossMonsterTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_statusEffects__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnitTracking_HPTracker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnitTracking_HPTrackerFunction__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UnitTracking_StatusEffectTracker__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MonsterStats__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_actions_boss__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_boss__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__damage_1_png__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__damage_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__damage_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__damage_5_png__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__damage_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__damage_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__heal_png__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__heal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__heal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MonsterTracker_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MonsterTracker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__MonsterTracker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BossMonsterTrackerComponent=function(_React$Component){_inherits(BossMonsterTrackerComponent,_React$Component);function BossMonsterTrackerComponent(props){_classCallCheck(this,BossMonsterTrackerComponent);var _this=_possibleConstructorReturn(this,(BossMonsterTrackerComponent.__proto__||Object.getPrototypeOf(BossMonsterTrackerComponent)).call(this,props));var statusEffects=__WEBPACK_IMPORTED_MODULE_4__lib_statusEffects__["j" /* STATUS_EFFECTS */].reduce(function(acc,s){acc[s]=false;return acc;},{});_this.state={statusEffects:statusEffects};return _this;}_createClass(BossMonsterTrackerComponent,[{key:"toggleStatusEffect",value:function toggleStatusEffect(statusEffect){this.setState({statusEffects:Object.assign({},this.state.statusEffects,_defineProperty({},statusEffect,!this.state.statusEffects[statusEffect]))});}},{key:"dealDamageBoss",value:function dealDamageBoss(index,damage){this.props.dealDamage(index,damage);this.forceUpdate();}},{key:"killBoss",value:function killBoss(name){this.props.removeBoss(name);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,index=_props.index,dealDamage=_props.dealDamage,boss=_props.boss;var stats=__WEBPACK_IMPORTED_MODULE_3__lib_monsters__["c" /* BOSS_STATS */][boss.name][this.props.scenarioLevel](this.props.numPlayers);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"MonsterTracker--Name"},this.props.boss.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.props.removeBoss(_this2.props.boss.name);}},"X")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MonsterStats__["a" /* MonsterStats */],{className:"MonsterTracker--Boss--Stats",stats:stats}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_2_classnames__("MonsterTracker--Boss--Stats","MonsterTracker--Boss--ImmunitiesContainer")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Immunities:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Boss--Immunities"},stats.immunities&&stats.immunities.map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:s,className:"MonsterTracker--Boss--ImmunityContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"MonsterTracker--Boss--Immunity",src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_statusEffects__["n" /* iconForStatusEffect */])(s),alt:"immune - "+s}));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Monster"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Monster--Controls"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Monster--Kill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return _this2.killBoss(boss.name);}},"Kill"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Monster--HP"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"MonsterTracker--Heal--Icon",src:__WEBPACK_IMPORTED_MODULE_14__heal_png___default.a,alt:"heal",onClick:function onClick(){return _this2.dealDamageBoss(_this2.props.index,-1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"MonsterTracker--Damage--Icon damage-1",src:__WEBPACK_IMPORTED_MODULE_12__damage_1_png___default.a,alt:"damage-1",onClick:function onClick(){return _this2.dealDamageBoss(_this2.props.index,1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"MonsterTracker--Damage--Icon damage-5",src:__WEBPACK_IMPORTED_MODULE_13__damage_5_png___default.a,alt:"damage-5",onClick:function onClick(){return _this2.dealDamageBoss(_this2.props.index,5);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UnitTracking_StatusEffectTracker__["a" /* StatusEffectTracker */],{statusEffects:this.state.statusEffects,immunities:stats.immunities,onToggle:function onToggle(s){return _this2.toggleStatusEffect(s);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnitTracking_HPTrackerFunction__["a" /* HPTrackerFunction */],{monsterData:this.props.boss}),this.props.numPlayers===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MonsterTracker--Boss--Cover"},"Add players"))));}}]);return BossMonsterTrackerComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var BossMonsterTracker=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{numPlayers:__WEBPACK_IMPORTED_MODULE_9__store_players__["b" /* selectors */].numPlayers(state),scenarioLevel:__WEBPACK_IMPORTED_MODULE_9__store_players__["b" /* selectors */].scenarioLevel(state)};},function(dispatch,ownProps){return{removeBoss:function removeBoss(name){return Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_boss__["c" /* removeBossAction */])(dispatch,name);},dealDamage:function dealDamage(index,damage){Object(__WEBPACK_IMPORTED_MODULE_11__store_boss__["a" /* dealDamageAction */])(dispatch,index,damage);}};})(BossMonsterTrackerComponent);

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var engine = __webpack_require__(6)

var storages = __webpack_require__(7)
var plugins = [__webpack_require__(4)]

module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.clearStorage = clearStorage;
exports.resetParentState = resetParentState;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _store = __webpack_require__(1);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleStorage = function (_Component) {
  _inherits(SimpleStorage, _Component);

  function SimpleStorage(props) {
    _classCallCheck(this, SimpleStorage);

    var _this = _possibleConstructorReturn(this, (SimpleStorage.__proto__ || Object.getPrototypeOf(SimpleStorage)).call(this, props));

    _this.state = {
      didHydrate: false,
      firedHydrateCallback: false
    };
    _this.testStorage = _testStorage.bind(_this);
    return _this;
  }

  _createClass(SimpleStorage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.testStorage() === true) {
        this.hydrateStateWithStorage();
        window.addEventListener("pagehide", this.saveStateToStorage.bind(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.testStorage() === true) {
        this.saveStateToStorage();
        window.removeEventListener("pagehide", this.saveStateToStorage.bind(this));
      }
    }
  }, {
    key: "testStorage",
    value: function testStorage() {
      var test = "test";
      try {
        _store2.default.set(test, test);
        _store2.default.remove(test);
        return true;
      } catch (e) {
        console.error("react-simple-storage could not access web storage.");
        return false;
      }
    }
  }, {
    key: "hydrateStateWithStorage",
    value: function hydrateStateWithStorage() {
      var prefix = "";
      var parent = {};

      if (this.props.parent) {
        parent = this.props.parent;
        prefix = this.props.prefix ? this.props.prefix : "";
      } else {
        console.error("No \"parent\" prop was provided to react-simple-storage. A parent component's context is required in order to access and update the parent component's state.\n\t\t\t\nTry the following: <SimpleStorage parent={this} />");
        return false;
      }

      // loop through storage
      _store2.default.each(function (value, key) {
        // if the storage item is in the current parent's state
        if (key.includes(prefix)) {
          // remove the parent-specific prefix to get original key from parent's state
          var name = key.slice(prefix.length + 1);

          // update parent's state with the result
          // store.js handles parsing
          var parsedValue = void 0;
          if (name in parent.state) {
            try {
              parsedValue = JSON.parse(value);
              parent.setState(_defineProperty({}, name, parsedValue));
            } catch (e) {
              parent.setState(_defineProperty({}, name, value));
            }
          }
        }
      });

      this.setState({ didHydrate: true });
    }
  }, {
    key: "saveStateToStorage",
    value: function saveStateToStorage() {
      var allowNewKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var prefix = "";
      var parent = {};
      var blacklist = [];

      if (this.props.parent) {
        prefix = this.props.prefix ? this.props.prefix : "";
        parent = this.props.parent;
        blacklist = this.props.blacklist || [];
      } else {
        console.error("No \"parent\" prop was provided to react-simple-storage. A parent component's context is required in order to access and update the parent component's state.\n      \nTry the following: <SimpleStorage parent={this} />");
        return false;
      }

      // loop through all of the parent's state
      for (var key in parent.state) {
        // save item to storage if not on the blacklist
        var prefixWithKey = prefix + "_" + key;
        if (blacklist.indexOf(key) < 0 && allowNewKey) {
          _store2.default.set(prefixWithKey, parent.state[key]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // callback function that fires after the parent's state has been hydrated with storage items
      if ('onParentStateHydrated' in props && state.didHydrate && !state.firedHydrateCallback) {
        props.onParentStateHydrated();
        return _extends({}, state, { firedHydrateCallback: true });
      }
      return state;
    }
  }]);

  return SimpleStorage;
}(_react.Component);

exports.default = SimpleStorage;


function _testStorage() {
  var test = "test";
  try {
    _store2.default.set(test, test);
    _store2.default.remove(test);
    return true;
  } catch (e) {
    console.error("react-simple-storage could not access any storage options.");
    return false;
  }
}

function clearStorage(prefix) {
  if (_testStorage() === true) {
    _store2.default.each(function (value, key) {
      if (key.includes(prefix)) {
        _store2.default.remove(key);
      }
    });
  }
}

function resetParentState(parent) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keysToIgnore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (_testStorage() === true) {
    for (var key in initialState) {
      // reset property if not in keys to ignore
      if (keysToIgnore.indexOf(key) < 0) {
        parent.setState(_defineProperty({}, key, initialState[key]));
      }
    }
  }
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = json2Plugin

function json2Plugin() {
	__webpack_require__(5)
	return {}
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/* eslint-disable */

//  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html

//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.

//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.

//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.

//          For example, this would serialize Dates as ISO strings.

//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };

//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.

//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.

//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.

//          JSON.stringify(undefined) returns undefined.

//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.

//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.

//          Example:

//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'

//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'

//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.

//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.

//          Example:

//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.

//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });

//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });

//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.

/*jslint
    eval, for, this
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== "object") {
    JSON = {};
}

(function () {
    "use strict";

    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10
            ? "0" + n
            : n;
    }

    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== "function") {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + "-" +
                        f(this.getUTCMonth() + 1) + "-" +
                        f(this.getUTCDate()) + "T" +
                        f(this.getUTCHours()) + ":" +
                        f(this.getUTCMinutes()) + ":" +
                        f(this.getUTCSeconds()) + "Z"
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap;
    var indent;
    var meta;
    var rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string)
            ? "\"" + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === "string"
                    ? c
                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + "\""
            : "\"" + string + "\"";
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i;          // The loop counter.
        var k;          // The member key.
        var v;          // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === "object" &&
                typeof value.toJSON === "function") {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === "function") {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case "string":
            return quote(value);

        case "number":

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value)
                ? String(value)
                : "null";

        case "boolean":
        case "null":

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce "null". The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is "object", we might be dealing with an object or an array or
// null.

        case "object":

// Due to a specification blunder in ECMAScript, typeof null is "object",
// so watch out for that case.

            if (!value) {
                return "null";
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === "[object Array]") {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || "null";
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? "[]"
                    : gap
                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
                        : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === "object") {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? "{}"
                : gap
                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
                    : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== "function") {
        meta = {    // table of character substitutions
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = "";
            indent = "";

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === "number") {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === "string") {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== "function" &&
                    (typeof replacer !== "object" ||
                    typeof replacer.length !== "number")) {
                throw new Error("JSON.stringify");
            }

// Make a fake root object containing our value under the key of "".
// Return the result of stringifying the value.

            return str("", {"": value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== "function") {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k;
                var v;
                var value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return "\\u" +
                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with "()" and "new"
// because they can cause invocation, and "=" because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
// replace all simple value tokens with "]" characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or "]" or
// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, "@")
                        .replace(rx_three, "]")
                        .replace(rx_four, "")
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval("(" + text + ")");

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return (typeof reviver === "function")
                    ? walk({"": j}, "")
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError("JSON.parse");
        };
    }
}());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = [
	// Listed in order of usage preference
	__webpack_require__(9),
	__webpack_require__(11),
	__webpack_require__(12),
	__webpack_require__(8),
	__webpack_require__(13),
	__webpack_require__(10)
]


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var util = __webpack_require__(0)
var Global = util.Global
var trim = util.trim

module.exports = {
	name: 'cookieStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var doc = Global.document

function read(key) {
	if (!key || !_has(key)) { return null }
	var regexpStr = "(?:^|.*;\\s*)" +
		escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
		"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
	return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
}

function each(callback) {
	var cookies = doc.cookie.split(/; ?/g)
	for (var i = cookies.length - 1; i >= 0; i--) {
		if (!trim(cookies[i])) {
			continue
		}
		var kvp = cookies[i].split('=')
		var key = unescape(kvp[0])
		var val = unescape(kvp[1])
		callback(val, key)
	}
}

function write(key, data) {
	if(!key) { return }
	doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
}

function remove(key) {
	if (!key || !_has(key)) {
		return
	}
	doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
}

function clearAll() {
	each(function(_, key) {
		remove(key)
	})
}

function _has(key) {
	return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0)
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var util = __webpack_require__(0)
var Global = util.Global

module.exports = {
	name: 'oldFF-globalStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var globalStorage = Global.globalStorage

function read(key) {
	return globalStorage[key]
}

function write(key, data) {
	globalStorage[key] = data
}

function each(fn) {
	for (var i = globalStorage.length - 1; i >= 0; i--) {
		var key = globalStorage.key(i)
		fn(globalStorage[key], key)
	}
}

function remove(key) {
	return globalStorage.removeItem(key)
}

function clearAll() {
	each(function(key, _) {
		delete globalStorage[key]
	})
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var util = __webpack_require__(0)
var Global = util.Global

module.exports = {
	name: 'oldIE-userDataStorage',
	write: write,
	read: read,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var storageName = 'storejs'
var doc = Global.document
var _withStorageEl = _makeIEStorageElFunction()
var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x

function write(unfixedKey, data) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.setAttribute(fixedKey, data)
		storageEl.save(storageName)
	})
}

function read(unfixedKey) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	var res = null
	_withStorageEl(function(storageEl) {
		res = storageEl.getAttribute(fixedKey)
	})
	return res
}

function each(callback) {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		for (var i=attributes.length-1; i>=0; i--) {
			var attr = attributes[i]
			callback(storageEl.getAttribute(attr.name), attr.name)
		}
	})
}

function remove(unfixedKey) {
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.removeAttribute(fixedKey)
		storageEl.save(storageName)
	})
}

function clearAll() {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		storageEl.load(storageName)
		for (var i=attributes.length-1; i>=0; i--) {
			storageEl.removeAttribute(attributes[i].name)
		}
		storageEl.save(storageName)
	})
}

// Helpers
//////////

// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
function fixKey(key) {
	return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
}

function _makeIEStorageElFunction() {
	if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
		return null
	}
	var scriptTag = 'script',
		storageOwner,
		storageContainer,
		storageEl

	// Since #userData storage applies only to specific paths, we need to
	// somehow link our data to a specific path.  We choose /favicon.ico
	// as a pretty safe option, since all browsers already make a request to
	// this URL anyway and being a 404 will not hurt us here.  We wrap an
	// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	// since the iframe access rules appear to allow direct access and
	// manipulation of the document element, even for a 404 page.  This
	// document can be used instead of the current document (which would
	// have been limited to the current path) to perform #userData storage.
	try {
		/* global ActiveXObject */
		storageContainer = new ActiveXObject('htmlfile')
		storageContainer.open()
		storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
		storageContainer.close()
		storageOwner = storageContainer.w.frames[0].document
		storageEl = storageOwner.createElement('div')
	} catch(e) {
		// somehow ActiveXObject instantiation failed (perhaps some special
		// security settings or otherwse), fall back to per-path storage
		storageEl = doc.createElement('div')
		storageOwner = doc.body
	}

	return function(storeFunction) {
		var args = [].slice.call(arguments, 0)
		args.unshift(storageEl)
		// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
		// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
		storageOwner.appendChild(storageEl)
		storageEl.addBehavior('#default#userData')
		storageEl.load(storageName)
		storeFunction.apply(this, args)
		storageOwner.removeChild(storageEl)
		return
	}
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(0)
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__players__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__summons__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__attackModifierDecks__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__boss__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__monsters__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__monsterDecks__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__turn__ = __webpack_require__(232);
var asyncDispatchMiddleware=function asyncDispatchMiddleware(store){return function(next){return function(action){var syncActivityFinished=false;var actionQueue=[];function flushQueue(){actionQueue.forEach(function(a){return store.dispatch(a);});// flush queue
actionQueue=[];}function asyncDispatch(asyncAction){actionQueue=actionQueue.concat([asyncAction]);if(syncActivityFinished){flushQueue();}}var actionWithAsyncDispatch=Object.assign({},action,{asyncDispatch:asyncDispatch});var res=next(actionWithAsyncDispatch);// console.log('next(actionWithAsyncDispatch)', res);
syncActivityFinished=true;flushQueue();return res;};};};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({players:__WEBPACK_IMPORTED_MODULE_1__players__["a" /* reducer */],summons:__WEBPACK_IMPORTED_MODULE_2__summons__["a" /* reducer */],attackModifierDecks:__WEBPACK_IMPORTED_MODULE_3__attackModifierDecks__["a" /* reducer */],elements:__WEBPACK_IMPORTED_MODULE_4__elements__["a" /* reducer */],boss:__WEBPACK_IMPORTED_MODULE_5__boss__["b" /* reducer */],monsters:__WEBPACK_IMPORTED_MODULE_6__monsters__["b" /* reducer */],monsterDecks:__WEBPACK_IMPORTED_MODULE_7__monsterDecks__["a" /* reducer */],turn:__WEBPACK_IMPORTED_MODULE_8__turn__["a" /* reducer */]}),Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(asyncDispatchMiddleware),window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nextSummonName */
/* unused harmony export baseStats */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* unused harmony export addSummonAction */
/* unused harmony export removeSummonAction */
/* unused harmony export toggleStatusEffectAction */
/* unused harmony export setHPAction */
/* unused harmony export selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_statusEffects__ = __webpack_require__(4);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var baseStats={name:"",hp:1,movement:0,attack:0,range:0,extra:""};function newSummon(summon,name){return Object.assign({},summon,{name:name,maxHP:summon.hp,statusEffects:Object(__WEBPACK_IMPORTED_MODULE_1__lib_statusEffects__["o" /* newStatusEffectTracker */])()});}var defaultState={};var ADD_SUMMON="summons/add";var REMOVE_SUMMON="summons/remove";var TOGGLE_STATUS_EFFECT="summons/statusEffects/toggle";var SET_HP="summons/hp/set";var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_party__["a" /* LOAD_PARTY */]:{return defaultState;}case ADD_SUMMON:{var summons=state[action.playerName];var name=action.summon.name?action.summon.name:"Summon #"+(summons?Object.keys(summons).length+1:1);return Object.assign({},state,_defineProperty({},action.playerName,Object.assign({},summons,_defineProperty({},name,newSummon(action.summon,name)))));}case REMOVE_SUMMON:{var newSummons=Object.assign({},state[action.playerName]);delete newSummons[action.name];return Object.assign({},state,_defineProperty({},action.playerName,newSummons));}case SET_HP:{return Object.assign({},state,_defineProperty({},action.playerName,Object.assign({},state[action.playerName],_defineProperty({},action.name,Object.assign({},state[action.playerName][action.name],{hp:action.hp})))));}case TOGGLE_STATUS_EFFECT:{return Object.assign({},state,_defineProperty({},action.playerName,Object.assign({},state[action.playerName],_defineProperty({},action.name,Object.assign({},state[action.playerName][action.name],{statusEffects:Object.assign({},state[action.playerName][action.name].statusEffects,_defineProperty({},action.statusEffect,!state[action.playerName][action.name].statusEffects[action.statusEffect]))})))));}default:return state;}};function addSummonAction(dispatch,playerName,summon){dispatch({type:ADD_SUMMON,playerName:playerName,summon:summon});}function removeSummonAction(dispatch,playerName,name){dispatch({type:REMOVE_SUMMON,playerName:playerName,name:name});}function toggleStatusEffectAction(dispatch,playerName,name,statusEffect){dispatch({type:TOGGLE_STATUS_EFFECT,playerName:playerName,name:name,statusEffect:statusEffect});}function setHPAction(dispatch,playerName,name,hp){dispatch({type:SET_HP,playerName:playerName,name:name,hp:hp});}function _nextSummonName(state,playerName){var summons=state[playerName];return playerName+" summon #"+(summons?Object.keys(summons).length+1:1);}var selectors={nextSummonName:function nextSummonName(state,name){return _nextSummonName(state.summons,name);}};

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* unused harmony export applyPerkUsageAction */
/* unused harmony export revealNextCardAction */
/* unused harmony export undoCardAction */
/* unused harmony export addCardAction */
/* unused harmony export removeCardAction */
/* unused harmony export selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_cards__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_classes__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_players__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_turn__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function newDeck(cards){return{cards:Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["i" /* shuffle */])(cards),currentIndex:-1,playedCards:[],curseCount:0,blessCount:0};}function newAttackModifierDeck(cards,characterClass){return Object.assign({},newDeck(cards),{class:characterClass,perkUsage:Object(__WEBPACK_IMPORTED_MODULE_1__lib_classes__["c" /* newPerksUsage */])(characterClass)||[],// from items
minusOneCards:0});}function newDeckWithPerks(characterClass,perkUsage,minusOneCards){var cards=__WEBPACK_IMPORTED_MODULE_0__lib_cards__["b" /* BASE_DECK */];perkUsage.forEach(function(pu,i){var cardModifierFn=Object(__WEBPACK_IMPORTED_MODULE_1__lib_classes__["d" /* perksForClass */])(characterClass)[i].modifyCards;pu.forEach(function(u){if(u){cards=cardModifierFn(cards);}});});cards=cards.concat(new Array(minusOneCards).fill(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["a" /* BASE_CARDS */].MINUS_ONE));return newDeck(cards);}function shuffleCards(cards,currentIndex){// remove played discards
var filteredCards=cards.filter(function(c,i){return!(c.endAction===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["e" /* END_ACTIONS */].DISCARD&&i<=currentIndex);});return Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["i" /* shuffle */])(filteredCards);}function revealNextCard(_ref){var cards=_ref.cards,currentIndex=_ref.currentIndex,playedCards=_ref.playedCards,curseCount=_ref.curseCount,blessCount=_ref.blessCount;var nextCards=cards;var nextIndex=currentIndex+1;var nextPlayedCards=playedCards;if(nextIndex>=cards.length){nextCards=shuffleCards(cards,currentIndex);nextIndex=0;nextPlayedCards=[];}var nextCard=nextCards[nextIndex];return{cards:nextCards,currentIndex:nextIndex,playedCards:[nextCard].concat(nextPlayedCards),curseCount:nextCard===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["d" /* CURSE */]?curseCount-1:curseCount,blessCount:nextCard===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["c" /* BLESS */]?blessCount-1:blessCount};}function addCard(deck,card){// in case of -1 index
var currentIndex=Math.max(0,deck.currentIndex);var randomIndex=Math.ceil(Math.random()*(deck.cards.length-currentIndex))+currentIndex;return{cards:[].concat(_toConsumableArray(deck.cards.slice(0,randomIndex)),[card],_toConsumableArray(deck.cards.slice(randomIndex))),curseCount:card===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["d" /* CURSE */]?deck.curseCount+1:deck.curseCount,blessCount:card===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["c" /* BLESS */]?deck.blessCount+1:deck.blessCount};}function removeCard(cards,currentIndex,cardToRemove){var matchedCards=cards.map(function(c,i){return[c,i,Math.random()];}).filter(function(_ref2,i){var _ref3=_toArray(_ref2),c=_ref3[0],rest=_ref3.slice(1);return i>currentIndex&&c===cardToRemove;});if(matchedCards.length===0){return cards;}// find largest random value aka pick one random number
var randomValue={value:matchedCards[0][2],index:matchedCards[0][1]};matchedCards.forEach(function(_ref4){var _ref5=_slicedToArray(_ref4,3),c=_ref5[0],i=_ref5[1],rand=_ref5[2];if(rand>randomValue.value){randomValue.value=rand;randomValue.index=i;}});return[].concat(_toConsumableArray(cards.slice(0,randomValue.index)),_toConsumableArray(cards.slice(randomValue.index+1)));}function handleUndoDiscard(cards,currentIndex,totalCount,cardToRemove){var newCards=cards;var countIncrease=0;if(totalCount===10){newCards=removeCard(cards,currentIndex,cardToRemove);}else{countIncrease=1;}return[newCards,countIncrease];}function undoCard(state,deckName){var deck=state[deckName];var cards=deck.cards,currentIndex=deck.currentIndex,playedCards=deck.playedCards,curseCount=deck.curseCount,blessCount=deck.blessCount;var newCards=cards;var newCurseCount=curseCount;var newBlessCount=blessCount;var countIncrease=0;var currentCard=cards[currentIndex];if(currentCard===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["d" /* CURSE */]){var totalCurseCount=deckName==="Monsters"?curseCount:totalCurseCards(state);var _handleUndoDiscard=handleUndoDiscard(cards,currentIndex,totalCurseCount,__WEBPACK_IMPORTED_MODULE_0__lib_cards__["d" /* CURSE */]);var _handleUndoDiscard2=_slicedToArray(_handleUndoDiscard,2);newCards=_handleUndoDiscard2[0];countIncrease=_handleUndoDiscard2[1];newCurseCount=newCurseCount+countIncrease;}else if(currentCard===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["c" /* BLESS */]){var totalBlessCount=totalBlessingCards(state);var _handleUndoDiscard3=handleUndoDiscard(cards,currentIndex,totalBlessCount,__WEBPACK_IMPORTED_MODULE_0__lib_cards__["c" /* BLESS */]);var _handleUndoDiscard4=_slicedToArray(_handleUndoDiscard3,2);newCards=_handleUndoDiscard4[0];countIncrease=_handleUndoDiscard4[1];newBlessCount=newBlessCount+countIncrease;}return{cards:newCards,currentIndex:currentIndex-1,playedCards:playedCards.slice(1),curseCount:newCurseCount,blessCount:newBlessCount};}function shuffleDeck(_ref6){var cards=_ref6.cards,currentIndex=_ref6.currentIndex;return{cards:shuffleCards(cards,currentIndex),currentIndex:-1,playedCards:[]};}var defaultState={Monsters:newAttackModifierDeck(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["b" /* BASE_DECK */],"")};var APPLY_PERK_USAGE="attackModifierDeck/cards/perks/applyUsage";var REVEAL_CARD="attackModifierDeck/cards/next";var ADD_CARD="attackModifierDeck/cards/add";var REMOVE_CARD="attackModifierDeck/cards/remove";var UNDO_CARD="attackModifierDeck/cards/undo";var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions_party__["a" /* LOAD_PARTY */]:{var loadedState=Object.entries(action.party[0]).reduce(function(acc,_ref7){var _ref8=_slicedToArray(_ref7,2),playerName=_ref8[0],playerData=_ref8[1];acc[playerName]=Object.assign({},newDeckWithPerks(playerData.class,playerData.perkUsage,playerData.minusOneCards),{class:playerData.class,perkUsage:playerData.perkUsage,minusOneCards:playerData.minusOneCards});return acc;},{});return Object.assign({},defaultState,loadedState);}case __WEBPACK_IMPORTED_MODULE_3__actions_players__["a" /* ADD_PLAYER */]:{return Object.assign({},state,_defineProperty({},action.name,newAttackModifierDeck(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["b" /* BASE_DECK */],action.class)));}case __WEBPACK_IMPORTED_MODULE_3__actions_players__["b" /* REMOVE_PLAYER */]:{var newState=Object.assign({},state);delete newState[action.name];return Object.assign({},newState);}case APPLY_PERK_USAGE:{var deck=state[action.deckName];return Object.assign({},state,_defineProperty({},action.deckName,Object.assign({},deck,{perkUsage:action.perkUsage,minusOneCards:action.minusOneCards},newDeckWithPerks(deck.class,action.perkUsage,action.minusOneCards))));}case REVEAL_CARD:{return Object.assign({},state,_defineProperty({},action.deckName,Object.assign({},state[action.deckName],revealNextCard(state[action.deckName]))));}case ADD_CARD:{var _deck=state[action.deckName];return Object.assign({},state,_defineProperty({},action.deckName,Object.assign({},_deck,addCard(_deck,action.card))));}case REMOVE_CARD:{var _deck2=state[action.deckName];return Object.assign({},state,_defineProperty({},action.deckName,Object.assign({},_deck2,{cards:removeCard(_deck2.cards,_deck2.currentIndex,action.card),curseCount:action.card===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["d" /* CURSE */]?_deck2.curseCount-1:_deck2.curseCount,blessCount:action.card===__WEBPACK_IMPORTED_MODULE_0__lib_cards__["c" /* BLESS */]?_deck2.blessCount-1:_deck2.blessCount})));}case UNDO_CARD:{return Object.assign({},state,_defineProperty({},action.deckName,Object.assign({},state[action.deckName],undoCard(state,action.deckName))));}case __WEBPACK_IMPORTED_MODULE_4__actions_turn__["b" /* END_TURN */]:{return Object.keys(state).reduce(function(acc,name){var deck=state[name];acc[name]=Object.assign({},deck,Object(__WEBPACK_IMPORTED_MODULE_0__lib_cards__["h" /* needsShuffle */])(deck)?shuffleDeck(deck):{playedCards:[]});return acc;},{});}default:return state;}};function applyPerkUsageAction(dispatch,name,perkUsage,minusOneCards){dispatch({type:APPLY_PERK_USAGE,deckName:name,perkUsage:perkUsage,minusOneCards:minusOneCards});}function revealNextCardAction(dispatch,name){dispatch({type:REVEAL_CARD,deckName:name});}function undoCardAction(dispatch,name){dispatch({type:UNDO_CARD,deckName:name});}function addCardAction(dispatch,name,card){dispatch({type:ADD_CARD,deckName:name,card:card});}function removeCardAction(dispatch,name,card){dispatch({type:REMOVE_CARD,deckName:name,card:card});}function totalCurseCards(state){return Object.keys(state).reduce(function(total,name){if(name==="Monsters"){return total;}return total+state[name].curseCount;},0);}function totalBlessingCards(state){return Object.keys(state).reduce(function(total,name){return total+state[name].blessCount;},0);}var selectors={totalCurses:function totalCurses(state){return totalCurseCards(state.attackModifierDecks);},totalBlessings:function totalBlessings(state){return totalBlessingCards(state.attackModifierDecks);}};

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_party__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_turn__ = __webpack_require__(2);
var defaultState=1;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_party__["a" /* LOAD_PARTY */]:{return defaultState;}case __WEBPACK_IMPORTED_MODULE_1__actions_turn__["b" /* END_TURN */]:{return state+1;}case __WEBPACK_IMPORTED_MODULE_1__actions_turn__["a" /* END_SCENARIO */]:{return 1;}default:return state;}};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.06e7cb6c.js